var buildModel = {
	"FLYER-M880": {
		"title": "Flyer<sup>&trade;</sup> M880",
		"options": [
			{
				"optionLabel": "Color",
				"sectionLabel": "Frame Size & Color",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/880/size-color.png",
				"optionCode": "color",
				"noSize": false,
				"customizeNote": "Find your perfect fit by selecting one of three frame sizes and customize with your choice of color.",
				"sectionSelect": ko.observable(false),
				"type": "radio",
				"selectedOption": ko.observable(),
				"optionItems": [
					{
						"sku": "880BK",
						"label": "Black",
						"reviewLabel": "Black M880",
						"code": "black",
						"price": 1799.00,
						"swatch": "#000000",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/bike-black.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/880/profile-black.png"
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/bike-black-hero.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/880/hero-black.png"
							}
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"allowDiscount": false,
						"discountPrice": 0,
						"disabled": ko.observable(false)
					},
					{
						"sku": "880R",
						"label": "Red",
						"reviewLabel": "Red M880",
						"code": "red",
						"price": 1799.00,
						"swatch": "#C81130",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/bike-red.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/880/profile-red.png"
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/bike-red-hero.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/880/hero-red.png"
							}
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"allowDiscount": false,
						"discountPrice": 0,
						"disabled": ko.observable(false)
					},
					{
						"sku": "880W",
						"label": "White",
						"reviewLabel": "White M880",
						"code": "white",
						"price": 1799.00,
						"swatch": "#F2F2F2",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/bike-white.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/880/profile-white.png"
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/bike-white-hero.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/880/hero-white.png"
							}
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"allowDiscount": false,
						"discountPrice": 0,
						"disabled": ko.observable(false)
					},
					{
						"sku": "880BL",
						"label": "Blue",
						"reviewLabel": "Blue M880",
						"code": "blue",
						"price": 1799.00,
						"swatch": "#54789D",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/bike-blue.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/880/profile-blue.png"
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/bike-blue-hero.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/880/hero-blue.png"
							}
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"allowDiscount": false,
						"discountPrice": 0,
						"disabled": ko.observable(false)
					}
				]
			},
			{
				"optionLabel": "Frame Size",
				"optionCode": "size",
				"extBattery": false,
				"type": "radio",
				"selectedOption": ko.observable(),
				"sectionSelect": ko.observable(false),
				"nextSec": "carriers",
				"customizeNote": "",
				"sectionLabel": "",
				"optionItems": [
					/* {
						"sku": "S",
						"label": "4'10'' - 5'8''",
						"reviewLabel" : "Small Frame Size (4'10'' - 5'8'')",
						"code": "small",
						"price": 0.00,
						"swatch": "Small",
						"allowQty": false,
						"currQty": ko.observable(1),
						"disabled": ko.observable(false)
					}, */
					{
						"sku": "",
						"label": "5'2'' - 6'3''",
						"reviewLabel": "Medium Frame Size (5'2'' - 6'3'')",
						"code": "medium",
						"price": 0.00,
						"swatch": "Medium",
						"allowQty": false,
						"currQty": ko.observable(1),
						"disabled": ko.observable(false)
					},
					{
						"sku": "L",
						"label": "5'8'' - 6'6''",
						"reviewLabel": "Large Frame Size (5'8'' - 6'6'')",
						"code": "large",
						"price": 0.00,
						"swatch": "Large",
						"allowQty": false,
						"currQty": ko.observable(1),
						"disabled": ko.observable(false)
					}
				]
			},
			{
				"optionLabel": "Kid Carriers",
				"sectionLabel": "Kid Carriers",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/880/carriers-new.png",
				"customizeNote": "Bring your little ones along for the ride. Choose from passenger seating for ages 9 months to 10 years.",
				"sectionSelect": ko.observable(false),
				"optionCode": "carriers",
				"prevSec": "color",
				"nextSec": "cargo",
				"type": "checkbox",
				"showOnlyLatest": true,
				"optionItems": [
					{
						"sku": "822Z",
						"label": "Flyer™ Duoflex",
						"code": "flyer-duoflex",
						"variantId": 47317443019025,
						"description": "From roll to stroll, the Flyer™ Duoflex is the ultimate bike trailer and double stroller for on-the-go families.",
						"price": 429.00,
						"link": "flyer-duoflex",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-flyer-duoflex.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-flyer-duoflex.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"discountPrice": 0,
						"allowDiscount": false
					},
					{
						"sku": "AC807",
						"label": "Kid & Cargo™ Carrier - 1 Kid",
						"code": "kid-cargo-carrier-1-kid",
						"variantId": 47317440168209,
						"description": "Ultimate versatility: travel with 1 kid passenger ages 5-10 years or haul up to 65 lbs.",
						"price": 199.00,
						"link": "kid-cargo-carrier-1-kid",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/kid-cargo-carrier.png",
								"layer": 2
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/kid-cargo-carrier-hero.png",
								"layer": 2
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-kid-cargo-carrier.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-kid-cargo-carrier.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": true,
						"discountPrice": 129.00,
						"latestGrouping": "rear"
					},
					{
						"sku": "AC806",
						"label": "Kid Carrier",
						"code": "kid-carrier",
						"variantId": 47317314568465,
						"description": "Bring 1 kid passenger ages 5-10 years old along for the ride with this comfortable kid carrier seat.",
						"price": 149.00,
						"link": "kid-carrier",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/kid-carrier.png",
								"layer": 2
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/kid-carrier-hero.png",
								"layer": 2
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-kid-carrier.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-kid-carrier.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": true,
						"discountPrice": 99,
						"latestGrouping": "rear"
					},
					/*
					{
						"sku": "AC844",
						"label": "Thule<sup>&reg;</sup> Yepp Nexxt 2 Maxi Child Seat",
						"code": "thule-yepp-nexxt-2-maxi-seat",
						"variantId": 47613239755025,
						"description": "Transport passengers ages 9 months to 6 years old, up to 40 lbs.",
						"price": 279.95,
						"link": "thule-yepp-nexxt-2-maxi-seat",
						"displayImages": {
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/thule-yepp-child-seat-{QTY}.png",
								"layer": 2
							},
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/thule-yepp-child-seat-hero-{QTY}.png",
								"layer": 2
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-thule-yepp-nexxt-child-seat.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-thule-yepp-nexxt-child-seat.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"latestGrouping": "rear"
					}
					*/
				]
			},
			{
				"optionLabel": "Cargo Storage",
				"sectionLabel": "Cargo Storage",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/880/cargo-storage.png",
				"customizeNote": "Choose the storage solution that is right for you by selecting from our assortment of cargo accessories.",
				"sectionSelect": ko.observable(false),
				"prevSec": "carriers",
				"nextSec": "Safety",
				"optionCode": "cargo",
				"type": "checkbox",
				"showOnlyLatest": true,
				"optionItems": [
					// {
					// 	"sku": "AC841",
					// 	"label": "Waterproof Front Storage Case & Basket",
					// 	"code": "wp-front-storage-case",
					// 	"variantId": 49907988529425,
					// 	"description": "Waterproof case holds up to 25 lbs. Securely attaches to the frame of the Flyer™ Front Storage Basket (Front Storage Basket included).",
					// 	"price": 228.00,
					// 	"link": "waterproof-front-storage-case",
					// 	"displayImages": {
					// 		"hero": {
					// 			"image": "https://images.radioflyer.com/media/flyer/build/880/front-storage-basket-waterproof.png",
					// 			"layer": 7
					// 		},
					// 		"profile": {
					// 			"image": "https://images.radioflyer.com/media/flyer/build/880/front-storage-basket-waterproof-hero.png",
					// 			"layer": 7
					// 		}
					// 	},
					// 	"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-front-storage-waterproof.png",
					// 	"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-front-storage-waterproof.png",
					// 	"allowQty": false,
					// 	"latest": false,
					// 	"currQty": ko.observable(1),
					// 	"selected": ko.observable(false),
					// 	"allowOptions": false,
					// 	"allowDiscount": false,
					// 	"discountPrice": 0,
					// 	"grouping": "small-front",
					// 	"latestGrouping": "front"
					// },
					{
						"sku": "AC801",
						"label": "Front Storage Basket",
						"code": "front-storage-basket",
						"variantId": 47317255323921,
						"description": "Features two cup holders and holds up to 25 lbs.",
						"price": 129.00,
						"link": "front-storage-basket",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/front-storage-basket.png",
								"layer": 7
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/front-storage-basket-hero.png",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-front-storage.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-front-storage-basket.png",
						"allowQty": false,
						"latest": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"grouping": "small-front",
						"latestGrouping": "front"
					},
					{
						"sku": "AC805 ",
						"label": "Front Rack",
						"code": "rack",
						"variantId": 47317320630545,
						"description": "Provides versatility & expands your hauling capacity. Holds up to 30 lbs",
						"price": 99.00,
						"link": "front-rack",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/front-rack.png",
								"layer": 7
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/front-rack-hero.png",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-front-rack.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-front-rack.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"latest": false,
						"latestGrouping": "front"
					},
					/*
					{
						"sku": "AC8421",
						"label": "Waterproof Rear Storage Case & Basket",
						"code": "wp-rear-storage-case",
						"variantId": 45818180174109,
						"description": "Waterproof case holds up to 50 lbs. Securely attaches to the frame of the Flyer™ Front Storage Basket (Front Storage Basket included).",
						"price": 159.00,
						"link": "waterproof-rear-storage-case-small-basket-bundle",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/rear-storage-basket-waterproof.png",
								"layer": 7
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/rear-storage-basket-waterproof-hero.png",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-rear-storage-waterproof.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-rear-storage-waterproof.png",
						"allowQty": false,
						"latest": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 238.00,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					},
					*/
					/* {
						"sku": "AC802",
						"label": "Small Rear Storage Basket",
						"code": "small-rear-storage-basket",
						"variantId": 47317256569105,
						"description": "Holds up to 50 lbs. Great for small bags, purses, & personal items.",
						"price": 129.00,
						"link": "rear-storage-basket-small",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/small-rear-storage-basket-{QTY}.png",
								"layer": 8
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/small-rear-storage-basket-hero-{QTY}.png",
								"layer": 8
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-rear-storage.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-small-rear-storage-basket.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 49.00,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					}, */
					{
						"sku": "AC846",
						"label": "Waterproof Pannier Bag",
						"code": "wp-pannier-bag",
						"variantId": 47317469528337,
						"description": "Waterproof storage. Holds up to 25 lbs. Quick disconnect for easy on & off.",
						"price": 149.00,
						"link": "waterproof-pannier-bag",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/880_ac846.png",
								"layer": 7
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/880_ac846.png",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-pannier.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/shown-on-bike-pannier.png",
						"allowQty": true,
						"latest": false,
						"currQty": ko.observable(1),
						"maxQty": 2,
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"latestGrouping": "rear"
					},
					{
						"sku": "AC834",
						"label": "Cargo Straps (2 Pack)",
						"code": "cargo-straps",
						"variantId": 47317447278865,
						"description": "Secure your belongings on the go. Durable, stretchable material. Pack includes 2 straps.",
						"price": 10.00,
						"link": "cargo-straps",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-cargo-straps.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-cargo-straps.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC835",
						"label": "Cargo Net",
						"code": "cargo-net",
						"variantId": 47317448032529,
						"description": "Secure your belongings on the go. Durable, stretchable material.",
						"price": 10.00,
						"link": "cargo-net",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-cargo-net.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-cargo-net.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 0
					}

				]
			},
			{
				"optionLabel": "Safety & Security",
				"sectionLabel": "Safety & Security",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/880/safe-secure.png?d=628",
				"customizeNote": "Explore accessories designed to keep you and your passengers safe and your bike secure.",
				"sectionSelect": ko.observable(false),
				"prevSec": "cargo",
				"nextSec": "rider-extras",
				"optionCode": "Safety",
				"type": "checkbox",
				"showOnlyLatest": false,
				"optionItems": [
					{
						"sku": "AC855",
						"label": "Kryptonite® Evolution 1090 Integrated",
						"code": "lock",
						"variantId": 47317319418129,
						"description": "High security 3’ heavy duty chain lock",
						"price": 120.95,
						"link": "kryptonite-evolution-1090",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-1090.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-1090.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC856",
						"label": "Kryptonite® KryptoLok 610 S Folding Lock ",
						"code": "lock",
						"variantId": 47317319647505,
						"description": "Moderate security compact folding lock",
						"price": 142.95,
						"link": "kryptonite-kryptolok-610",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-610.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-610.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC857",
						"label": "Kryptonite® Evolution Standard U Lock",
						"code": "lock",
						"variantId": 47317319909649,
						"description": "High security 14 mm steel U-lock",
						"price": 129.95,
						"link": "kryptonite-evolution-standard-u-lock",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-evolution.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-evolution.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC858",
						"label": "Kryptonite® KryptoLok Standard U",
						"code": "lock",
						"variantId": 47317320073489,
						"description": "Moderate security 12.7 mm steel U-lock",
						"price": 72.95,
						"link": "kryptonite-kryptolok-standard-u-lock",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-krypto.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-krypto.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC859",
						"label": "Kryptonite® KryptoFlex 710 Double Loop Cable ",
						"code": "lock",
						"variantId": 47317320368401,
						"description": "7’ cable to secure front wheel when used with a Kryptonite® lock. Please note this is a cable only (not a lock).",
						"price": 26.95,
						"link": "kryptonite-kryptoflex-710-cable",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-710.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-710.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC821",
						"label": "Handlebar Bike Mirror",
						"code": "rear-view-mirror",
						"variantId": 47317262139665,
						"description": "Blindspot coverage while you ride. Splash and crack resistant.",
						"price": 39.00,
						"link": "",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-rear-view-mirror.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-rear-view-mirror.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC818",
						"label": "Bern® Hudson Adult Helmet",
						"code": "bern-hudson-adult-helmet",
						"description": "The optimal combination of style, comfort, and protection.",
						"price": 159.00,
						"link": "bern-hudson-adult-helmet",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/ac818-img-hero.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/ac818-img-cart-small.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"options": [
							{
								"sku": "S",
								"code": "small",
								"variantId": 47317277245713,
								"label": "Small",
								"selected": ko.observable(false)
							},
							/*{
								"sku": "M",
								"code": "medium",
								"variantId": 47317277475089,
								"label": "Medium",
								"selected": ko.observable(true)
							},*/
							{
								"sku": "L",
								"code": "large",
								"variantId": 47317277606161,
								"label": "Large",
								"selected": ko.observable(true)
							}
						]
					},
					{
						"sku": "AC876BK",
						"label": "Bern® Nino DVRT Youth Helmet, Black",
						"code": "bern-nino-dvrt-youth-helmet-black",
						"description": "Safe, stylish, and designed for a quick and easy fit for young riders.",
						"price": 79.00,
						"link": "bern-nino-dvrt-youth-helmet-black",
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2.png",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"options": [
							{
								"sku": "XS/S",
								"code": "small",
								"variantId": 50030924955921,
								"label": "Small",
								"selected": ko.observable(false)
							},
							 {
								"sku": "S/M",
								"code": "medium",
								"variantId": 50030924988689,
								"label": "Medium",
								"selected": ko.observable(true)
							} 
						]
					},
					{
						"sku": "AC876BL",
						"label": "Bern® Nino DVRT Youth Helmet, Blue",
						"code": "bern-nino-dvrt-youth-helmet-blue",
						"description": "Safe, stylish, and designed for a quick and easy fit for young riders.",
						"price": 79.00,
						"link": "bern-nino-dvrt-youth-helmet-blue",
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2-blue.png",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2-blue.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"options": [
							{
								"sku": "XS/S",
								"code": "small",
								"variantId": 50030906835217,
								"label": "Small",
								"selected": ko.observable(false)
							},
							{
								"sku": "S/M",
								"code": "medium",
								"variantId": 50030906867985,
								"label": "Medium",
								"selected": ko.observable(true)
							}
						]
					}]
			},
			{
				"optionLabel": "Rider Extras",
				"sectionLabel": "Rider Extras",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/880/rider-extra.png",
				"customizeNote": "Load your electric bike with all of the accessories you need for a comfortable ride.",
				"sectionSelect": ko.observable(false),
				"optionCode": "rider-extras",
				"prevSec": "Safety",
				"nextSec": "rack",
				"type": "checkbox",
				"showOnlyLatest": false,
				"optionItems": [
					{
						"sku": "AC848",
						"label": "Waterproof Bike Cover",
						"code": "waterproof-bike-cover",
						"variantId": 49941773451537,
						"description": "Protect your bike from the elements.",
						"price": 64.00,
						"link": "waterproof-bike-cover",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-waterproof-bike-cover.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-waterproof-bike-cover.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC866",
						"label": "Spare Battery",
						"code": "spare-battery-m880",
						"variantId": 47952099377425,
						"description": "Extend ride time with a spare bike battery – charge one while you ride with the other.",
						"price": 499.00,
						"link": "",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-ac866.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-ac866.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, 
					{
						"sku": "AC822",
						"label": "Cell Phone Mount",
						"code": "cell-phone-mount",
						"variantId": 47317263417617,
						"description": "Secure your phone while you ride. Compatible with phones 3.5”-6.5''",
						"price": 29.00,
						"link": "",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-cell-phone.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-cell-phone.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC825",
						"label": "Handlebar Water Bottle Holder",
						"code": "water-bottle-holder",
						"variantId": 47317264761105,
						"description": "Holds any standard-sized water bottle. Quick release for easy access.",
						"price": 29.00,
						"link": "",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-water-holder.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-water-holder.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC824",
						"label": "Water Bottle",
						"code": "water-bottle",
						"variantId": 47317264466193,
						"description": "Hydrate on the go with this BPA free 20 oz. water bottle.",
						"price": 14.00,
						"link": "",
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/products/water-bottle-model-ac822-shop.jpg",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-water-bottle.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC838",
						"label": "Battery & Charger Holder",
						"code": "water-bottle",
						"variantId": 47317512552721,
						"description": "Secure storage for your Flyer™ eBike battery & charger.",
						"price": 49.00,
						"link": "battery-charger-holder",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-ac838.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-ac838.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 0
					}
				]
			},
			{
				"optionLabel": "Bike Rack",
				"sectionLabel": "Bike Rack",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/880/rack.png",
				"customizeNote": "",
				"sectionSelect": ko.observable(false),
				"optionCode": "rack",
				"prevSec": "rider-extras",
				"nextSec": "review",
				"type": "checkbox",
				"showOnlyLatest": false,
				"optionItems": [

					{
						"sku": "AC850",
						"label": "Hollywood Racks® Sport Rider Rack with Adapter",
						"code": "rack",
						"variantId": 47317331509521,
						"description": "Carry up to 2 bikes. Adapter for one Flyer™ eBike included.",
						"price": 548.00,
						"link": "",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-rack.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-rack.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 0
					}
				]
			}
		]
	},
	"FLYER-860": {
		"title": "Flyer<sup>&trade;</sup> Folding Cargo",
		"options": [
			{
				"optionLabel": "Color",
				"sectionLabel": "Frame Color",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/860/color-menu.png?d=1022",
				"optionCode": "color",
				"nextSec": "carriers",
				"noSize": true,
				"extBattery": false,
				"customizeNote": "Customize your ride with your choice of color.",
				"sectionSelect": ko.observable(false),
				"type": "radio",
				"selectedOption": ko.observable(),
				"optionItems": [
					{
						"sku": "860BK",
						"label": "Black",
						"reviewLabel": "Black Folding Cargo eBike",
						"code": "black",
						"variantId": 49721280856337,
						"price": 999.00,
						"swatch": "#000000",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0022_Black.png?v=1726155443",
								"layer": 1,
								"thumbnail": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0022_Black.png?v=1726155443"
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0022_Black.png?v=1726155443",
								"layer": 1,
								"thumbnail": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0022_Black.png?v=1726155443"
							}
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"allowDiscount": false,
						"discountPrice": 0,
						"disabled": ko.observable(false)
					},
					{
						"sku": "860R",
						"label": "Red",
						"reviewLabel": "Red Folding Cargo eBike",
						"code": "red",
						"variantId": 49721280889105,
						"price": 999.00,
						"swatch": "#C81130",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0021_Red.png?v=1726155443",
								"layer": 1,
								"thumbnail": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0021_Red.png?v=1726155443"
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0021_Red.png?v=1726155443",
								"layer": 1,
								"thumbnail": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0021_Red.png?v=1726155443"
							}
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"allowDiscount": false,
						"discountPrice": 0,
						"disabled": ko.observable(false)
					},
					{
						"sku": "860W",
						"label": "White",
						"reviewLabel": "White Folding Cargo eBike",
						"code": "white",
						"variantId": 49721280921873,
						"price": 999.00,
						"swatch": "#F2F2F2",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0023_White.png?v=1726155443",
								"layer": 1,
								"thumbnail": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0023_White.png?v=1726155443"
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0023_White.png?v=1726155443",
								"layer": 1,
								"thumbnail": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0023_White.png?v=1726155443"
							}
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"allowDiscount": false,
						"discountPrice": 0,
						"disabled": ko.observable(false)
					},
					{
						"sku": "860G",
						"label": "Green",
						"reviewLabel": "Green Folding Cargo eBike",
						"code": "green",
						"variantId": 49721280954641,
						"price": 999.00,
						"swatch": "#707839",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0020_Green.png?v=1726155443",
								"layer": 1,
								"thumbnail": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0020_Green.png?v=1726155443"
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0020_Green.png?v=1726155443",
								"layer": 1,
								"thumbnail": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0020_Green.png?v=1726155443"
							}
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"allowDiscount": false,
						"discountPrice": 0,
						"disabled": ko.observable(false)
					}
				]
			},
			{
				"optionLabel": "Kid & Pet Carriers",
				"sectionLabel": "Kid & Pet Carriers",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/880/carriers-new.png",
				"customizeNote": "Add kid & pet carrier accessories to create the perfect ride for your crew.",
				"sectionSelect": ko.observable(false),
				"optionCode": "carriers",
				"prevSec": "color",
				"nextSec": "cargo",
				"type": "checkbox",
				"showOnlyLatest": true,
				"optionItems": [
					{
						"sku": "AC807FBK",
						"label": "Kid & Cargo™ Carrier - 1 Kid",
						"code": "kid-cargo-carrier-black-1-kid",
						"variantId": 49948012380433,
						"description": "Ultimate versatility: travel with 1 kid passenger ages 5-10 years or haul up to 65 lbs.",
						"price": 199.00,
						"link": "kid-cargo-carrier-black-1-kid?variant=49948012380433",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0004_AC807BK----KidCargoCarrier.png?v=1726155437",
								"layer": 2
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0004_AC807BK----KidCargoCarrier.png?v=1726155437",
								"layer": 2
							}
						},
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-AC807-right.png?v=1723650677",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC807BK-bottom.png?v=1723647714",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"flyerProd": true,
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 129,
						"latestGrouping": "rear"
					},
					{
						"sku": "AC865",
						"label": "Wag 'N Ride Pet Carrier",
						"code": "wag-n-ride-pet-carrier",
						"variantId": 50135024533777,
						"description": "For pets up to 30 lbs. Feature removable top, 4 mesh windows, and adjustable leash.",
						"price": 149.00,
						"link": "wag-n-ride-pet-carrier",
						"displayImages": {
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0003_AC865---Pet-Carrier.png?v=1726155440",
								"layer": 7
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0003_AC865---Pet-Carrier.png?v=1726155440",
								"layer": 7
							}
						},
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC865-right.png?v=1723738465",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC865BK-AC807BK-bottom.png?v=1723647715",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"maxQty": 2,
						"selected": ko.observable(false),
						"required": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 49,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					},
					{
						"sku": "AC806FBK",
						"label": "Kid Carrier",
						"code": "kid-carrier-black",
						"variantId": 50169617219857,
						"description": "Bring 1 kid passenger ages 5-10 years old along for the ride with this comfortable kid carrier seat.",
						"price": 149.00,
						"link": "kid-carrier-black?variant=50169617219857",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0012_AC806BK.png?v=1726155439",
								"layer": 2
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0012_AC806BK.png?v=1726155439",
								"layer": 2
							}
						},
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-AC806-right.png?v=1723650678",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-kid-carrier.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 99,
						"latestGrouping": "rear"
					},
					{
						"sku": "AC844",
						"label": "Thule<sup>&reg;</sup> Yepp Nexxt 2 Maxi Child Seat",
						"code": "thule-yepp-nexxt-2-maxi-seat",
						"variantId": 47613239755025,
						"description": "Transport passengers ages 9 months to 6 years old, up to 40 lbs.",
						"price": 279.95,
						"link": "thule-yepp-nexxt-2-maxi-seat",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0008_AC844-REND---Thule.png?v=1726155439",
								"layer": 2
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0008_AC844-REND---Thule.png?v=1726155439",
								"layer": 2
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-thule-yepp-nexxt-child-seat.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-thule-yepp-nexxt-child-seat.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"latestGrouping": "rear"
					},
					{
						"sku": "822Z",
						"label": "Flyer™ Duoflex",
						"code": "flyer-duoflex",
						"variantId": 47317443019025,
						"description": "From roll to stroll, the Flyer™ Duoflex is the ultimate bike trailer and double stroller for on-the-go families.",
						"price": 429.00,
						"link": "flyer-duoflex",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-flyer-duoflex.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-flyer-duoflex.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					}
				]
			},
			{
				"optionLabel": "Cargo Storage",
				"sectionLabel": "Cargo Storage",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/880/cargo-storage.png",
				"customizeNote": "Choose the storage solution that is right for you by selecting from our assortment of cargo accessories.",
				"sectionSelect": ko.observable(false),
				"prevSec": "carriers",
				"nextSec": "Safety",
				"optionCode": "cargo",
				"type": "checkbox",
				"showOnlyLatest": true,
				"optionItems": [
					{
						"sku": "AC801BK",
						"label": "Front Storage Basket",
						"code": "front-storage-basket",
						"variantId": 48712895136017,
						"description": "Features two cup holders and holds up to 25 lbs.",
						"price": 129.00,
						"link": "front-storage-basket-black",
						"notes": "",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0018_AC801BK.png?v=1726155438",
								"layer": 7
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0018_AC801BK.png?v=1726155438",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-front-storage-bk-new.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-front-storage-bk.png",
						"allowQty": false,
						"latest": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 69,
						"grouping": "small-front",
						"latestGrouping": "front"
					},
					/* {
						"sku": "AC841",
						"label": "Waterproof Front Storage Case & Basket",
						"code": "wp-front-storage-case",
						"variantId": 49907988529425,
						"description": "Waterproof case holds up to 25 lbs. Securely attaches to the frame of the Flyer™ Front Storage Basket (Front Storage Basket included).",
						"price": 228.00,
						"link": "waterproof-front-storage-case",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0017_AC841.png?v=1726155438",
								"layer": 7
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0017_AC841.png?v=1726155438",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/860/inset-front-waterproof.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-front-storage-waterproof.png",
						"allowQty": false,
						"latest": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 129,
						"grouping": "small-front",
						"latestGrouping": "front"
					}, */
					{
						"sku": "AC805BK",
						"label": "Front Rack",
						"code": "rack",
						"variantId": 48712883732753,
						"description": "Provides versatility & expands your hauling capacity. Holds up to 30 lbs",
						"price": 99.00,
						"link": "front-rack-black",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0019_AC805BK.png?v=1726155437",
								"layer": 7
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0019_AC805BK.png?v=1726155437",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-front-rack-bk.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-front-rack-bk.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 39,
						"latest": false,
						"latestGrouping": "front"
					},
					{
						"sku": "AC808",
						"label": "Carry & Go Tote Bag",
						"code": "carry-go-tote",
						"variantId": 48712879309073,
						"description": "Holds up to 60 lbs. and features internal zipper pocket. Folds flat on bike. Made with 100% recycled fabric.",
						"price": 69.00,
						"link": "carry-go-tote-bag",
						"displayImages": {
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0002_AC808---Tote-Bag.png?v=1726155439",
								"layer": 7
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0002_AC808---Tote-Bag.png?v=1726155439",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-carry-go-tote.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-carry-go-tote.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"maxQty": 2,
						"selected": ko.observable(false),
						"required": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 49,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					},
					{
						"sku": "AC869",
						"label": "36L Soft Cooler",
						"code": "36l-soft-cooler",
						"variantId": 50940682076433,
						"description": "Perfect for traveling & on-the-go adventures. Insulated, durable, and waterproof. Holds up to 80 lbs.",
						"price": 149.00,
						"link": "36l-soft-cooler",
						"displayImages": {
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/860/AC869.png",
								"layer": 8
							},
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/860/AC869.png",
								"layer": 8
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/ac869-cooler.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/ac869-cooler.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 49,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					},
					{
						"sku": "AC802BK",
						"label": "Small Rear Storage Basket",
						"code": "small-rear-storage-basket",
						"variantId": 48712887861521,
						"description": "Holds up to 50 lbs. Great for small bags, purses, & personal items.",
						"price": 129.00,
						"link": "rear-storage-basket-black-small",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0006_AC802BK---Rear-Storage-Bag.png?v=1726155438",
								"layer": 8
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0006_AC802BK---Rear-Storage-Bag.png?v=1726155438",
								"layer": 8
							}
						},
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC802BK-right.png?v=1723652171",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC802BK-Bottom.png?v=1723652171",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 49,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					},
					/* {
						"sku": "AC8421",
						"label": "Waterproof Rear Storage Case & Basket",
						"code": "wp-rear-storage-case",
						"variantId": 45818180174109,
						"description": "Waterproof case holds up to 50 lbs. Securely attaches to the frame of the Flyer™ Rear Storage Basket (Rear Storage Basket included).",
						"price": 238.00,
						"link": "waterproof-rear-storage-case-small-basket-bundle",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0007_AC842---Rear-Waterproof-Bag.png?v=1726155438",
								"layer": 7
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0007_AC842---Rear-Waterproof-Bag.png?v=1726155438",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/860/inset-rear-waterproof.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-rear-storage-waterproof.png",
						"allowQty": false,
						"latest": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 129,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					}, */
					{
						"sku": "AC847",
						"label": "Waterproof Frame Storage Case ",
						"code": "waterproof-frame-storage-case",
						"variantId": 47317479784721,
						"description": "Waterproof storage. Holds up to 6 lbs. Great for keys, wallets, and phones.",
						"price": 34.00,
						"link": "waterproof-frame-storage-case",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0005_AC847---Waterproof-Case.png?v=1726155436",
								"layer": 8
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0005_AC847---Waterproof-Case.png?v=1726155436",
								"layer": 8
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/ac847-right-side.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/ac847-shown-on-bike.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"latest": false,
						"latestGrouping": "middle"
					},
					{
						"sku": "AC874",
						"label": "Catch-All Bag",
						"code": "catch-all",
						"variantId": 50582958965009,
						"description": "Convenient on-the-go storage. Holds a 32 oz. water bottle or up to 6 lbs. Great for phones, keys, or snacks. Features external mesh pocket and Velcro straps for secure attachment.",
						"notes": "",
						"price": 15.00,
						"link": "catch-all-bag",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/860/catch-all.png",
								"layer": 10
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/860/catch-all.png",
								"layer": 10
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-catch-all.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-ac874.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"required": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
					},
					{
						"sku": "AC846",
						"label": "Waterproof Pannier Bag",
						"code": "wp-pannier-bag",
						"variantId": 47317469528337,
						"description": "Waterproof storage. Holds up to 25 lbs. Quick disconnect for easy on & off.",
						"price": 149.00,
						"link": "waterproof-pannier-bag",
						"displayImages": {
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0009_AC846-pannier.png?v=1726155439",
								"layer": 7
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0009_AC846-pannier.png?v=1726155439",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-pannier.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/shown-on-bike-pannier.png",
						"allowQty": true,
						"latest": false,
						"currQty": ko.observable(1),
						"maxQty": 2,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"latestGrouping": "rear"
					},
					{
						"sku": "AC834",
						"label": "Cargo Straps (2 Pack)",
						"code": "cargo-straps",
						"variantId": 47317447278865,
						"description": "Secure your belongings on the go. Durable, stretchable material. Pack includes 2 straps.",
						"price": 10.00,
						"link": "cargo-straps",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-cargo-straps.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-cargo-straps.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC835",
						"label": "Cargo Net",
						"code": "cargo-net",
						"variantId": 47317448032529,
						"description": "Secure your belongings on the go. Durable, stretchable material.",
						"price": 10.00,
						"link": "cargo-net",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-cargo-net.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-cargo-net.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					}

				]
			},
			{
				"optionLabel": "Safety & Security",
				"sectionLabel": "Safety & Security",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/880/safe-secure.png?d=628",
				"customizeNote": "Explore accessories designed to keep you and your passengers safe and your bike secure.",
				"sectionSelect": ko.observable(false),
				"prevSec": "cargo",
				"nextSec": "rider-extras",
				"optionCode": "Safety",
				"type": "checkbox",
				"showOnlyLatest": false,
				"optionItems": [
					{
						"sku": "AC827",
						"label": "Bar End Bike Mirror",
						"code": "rear-view-mirror",
						"variantId": 47317351203089,
						"description": "Blindspot coverage while you ride. Splash and crack resistant.",
						"price": 39.00,
						"link": "bar-end-bike-mirror",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/860/AC827.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-side-mirror.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0011_ac827-mirror.png?v=1726155436",
								"layer": 8
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0011_ac827-mirror.png?v=1726155436",
								"layer": 8
							}
						}
					}, {
						"sku": "AC855 ",
						"label": "Kryptonite® Evolution 1090 Integrated",
						"code": "lock",
						"variantId": 47317319418129,
						"description": "High security 3’ heavy duty chain lock",
						"price": 120.95,
						"link": "kryptonite-evolution-1090",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-1090.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-1090.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC856  ",
						"label": "Kryptonite® KryptoLok 610 S Folding Lock ",
						"code": "lock",
						"variantId": 47317319647505,
						"description": "Moderate security compact folding lock",
						"price": 142.95,
						"link": "kryptonite-kryptolok-610",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-610.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-610.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC857 ",
						"label": "Kryptonite® Evolution Standard U Lock",
						"code": "lock",
						"variantId": 47317319909649,
						"description": "High security 14 mm steel U-lock",
						"price": 129.95,
						"link": "kryptonite-evolution-standard-u-lock",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-evolution.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-evolution.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC858",
						"label": "Kryptonite® KryptoLok Standard U",
						"code": "lock",
						"variantId": 47317320073489,
						"description": "Moderate security 12.7 mm steel U-lock",
						"price": 72.95,
						"link": "kryptonite-kryptolok-standard-u-lock",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-krypto.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-krypto.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC859",
						"label": "Kryptonite® KryptoFlex 710 Double Loop Cable ",
						"code": "lock",
						"variantId": 47317320368401,
						"description": "7’ cable to secure front wheel when used with a Kryptonite® lock. Please note this is a cable only (not a lock).",
						"price": 26.95,
						"link": "kryptonite-kryptoflex-710-cable",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-710.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-710.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC818",
						"label": "Bern® Hudson Adult Helmet",
						"code": "bern-hudson-adult-helmet",
						"description": "The optimal combination of style, comfort, and protection.",
						"price": 159.00,
						"link": "bern-hudson-adult-helmet",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/ac818-img-hero.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/ac818-img-cart-small.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": true,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"options": [
							{
								"sku": "S",
								"code": "small",
								"variantId": 47317277245713,
								"label": "Small",
								"selected": ko.observable(false)
							},
							/*{
								"sku": "M",
								"code": "medium",
								"variantId": 47317277475089,
								"label": "Medium",
								"selected": ko.observable(true)
							},*/
							{
								"sku": "L",
								"code": "large",
								"variantId": 47317277606161,
								"label": "Large",
								"selected": ko.observable(true)
							}
						]
					},
					{
						"sku": "AC876BK",
						"label": "Bern® Nino DVRT Youth Helmet, Black",
						"code": "bern-nino-dvrt-youth-helmet-black",
						"description": "Safe, stylish, and designed for a quick and easy fit for young riders.",
						"price": 79.00,
						"link": "bern-nino-dvrt-youth-helmet-black",
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2.png",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": true,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"options": [
							{
								"sku": "XS/S",
								"code": "small",
								"variantId": 50030924955921,
								"label": "Small",
								"selected": ko.observable(false)
							},
							 {
								"sku": "S/M",
								"code": "medium",
								"variantId": 50030924988689,
								"label": "Medium",
								"selected": ko.observable(true)
							} 
						]
					},
					{
						"sku": "AC876BL",
						"label": "Bern® Nino DVRT Youth Helmet, Blue",
						"code": "bern-nino-dvrt-youth-helmet-blue",
						"description": "Safe, stylish, and designed for a quick and easy fit for young riders.",
						"price": 79.00,
						"link": "bern-nino-dvrt-youth-helmet-blue",
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2-blue.png",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2-blue.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": true,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"options": [
							{
								"sku": "XS/S",
								"code": "small",
								"variantId": 50030906835217,
								"label": "Small",
								"selected": ko.observable(false)
							},
							{
								"sku": "S/M",
								"code": "medium",
								"variantId": 50030906867985,
								"label": "Medium",
								"selected": ko.observable(true)
							}
						]
					}]
			},
			{
				"optionLabel": "Rider Extras",
				"sectionLabel": "Rider Extras",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/880/rider-extra.png",
				"customizeNote": "Load your electric bike with all of the accessories you need for a comfortable ride.",
				"sectionSelect": ko.observable(false),
				"optionCode": "rider-extras",
				"prevSec": "Safety",
				"nextSec": "review",
				"type": "checkbox",
				"showOnlyLatest": false,
				"optionItems": [
					{
						"sku": "AC848",
						"label": "Waterproof Bike Cover",
						"code": "waterproof-bike-cover",
						"variantId": 49941773451537,
						"description": "Protect your bike from the elements.",
						"price": 64.00,
						"link": "waterproof-bike-cover",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-waterproof-bike-cover.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-waterproof-bike-cover.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC822",
						"label": "Cell Phone Mount",
						"code": "cell-phone-mount",
						"variantId": 47317351072017,
						"description": "Secure your phone while you ride. Compatible with phones 3.5”-6.5''",
						"price": 29.00,
						"link": "",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-cell-phone.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-cell-phone.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowOptionsWithImages": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0010_ac822-phone-mount.png?v=1726155436",
								"layer": 8
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0010_ac822-phone-mount.png?v=1726155436",
								"layer": 8
							}
						}
					},
					{
						"sku": "AC828",
						"label": "Water Bottle Cage",
						"code": "water-bottle-cage",
						"description": "Holds any standard-sized water bottle. Quick release for easy access.",
						"price": 19.00,
						"link": "",
						"optionImage": {
							"black": "https://images.radioflyer.com/media/flyer/build/860/AC828B.png",
							"silver": "https://images.radioflyer.com/media/flyer/build/860/AC828S.png"
						},
						"cartImage": {
							"black": "https://images.radioflyer.com/media/flyer/build/cart-water-cage-black.png",
							"silver": "https://images.radioflyer.com/media/flyer/build/cart-water-cage-silver.png",
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"imageOption": ko.observable('black'),
						"allowOptions": true,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"latest": false,
						"latestGrouping": "middle",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0014_ac828B.png?v=1726155436",
								"layer": 8
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/860-BUILD_0014_ac828B.png?v=1726155436",
								"layer": 8
							}
						},
						"options": [
							{
								"sku": "B",
								"swatch": "black",
								"code": "black",
								"variantId": 47317354938641,
								"label": "Black",
								"selected": ko.observable(true)
							},
							{
								"sku": "S",
								"swatch": "#d9d9db",
								"code": "silver",
								"variantId": 47317355626769,
								"label": "Silver",
								"selected": ko.observable(false)
							}
						]
					},
					{
						"sku": "AC824",
						"label": "Water Bottle",
						"code": "water-bottle",
						"variantId": 47317264466193,
						"description": "Hydrate on the go with this BPA free 20 oz. water bottle.",
						"price": 14.00,
						"link": "",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-water-bottle-860.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-water-bottle-860.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC867",
						"label": "Spare Battery",
						"code": "spare-battery-cruisers-folding-cargo",
						"variantId": 47952103506193,
						"description": "Extend ride time with a spare bike battery – charge one while you ride with the other.",
						"price": 399.00,
						"link": "spare-battery-cruisers-folding-cargo",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-ac867.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-ac867.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC838",
						"label": "Battery & Charger Holder",
						"code": "water-bottle",
						"variantId": 47317512552721,
						"description": "Secure storage for your Flyer™ eBike battery & charger.",
						"price": 49.00,
						"link": "battery-charger-holder",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-ac838.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-ac838.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					}
				]
			}


		]
	},
	"FLYER-852": {
		"title": "Flyer<sup>&trade;</sup> Cruiser Step-Thru 2.0",
		"options": [
			{
				"optionLabel": "Color",
				"sectionLabel": "Frame Color",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/852/color-menu.png?d=1022",
				"optionCode": "color",
				"nextSec": "carriers",
				"noSize": true,
				"extBattery": false,
				"customizeNote": "Customize your ride with your choice of color.",
				"sectionSelect": ko.observable(false),
				"type": "radio",
				"selectedOption": ko.observable(),
				"optionItems": [
					{
						"sku": "852G",
						"label": "Mint",
						"reviewLabel": "Mint Cruiser eBike",
						"code": "mint",
						"variantId": 49721295339793,
						"price": 1399.00,
						"swatch": "#BDD5B7",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0024_Mint.png?v=1724959167",
								"layer": 1,
								"thumbnail": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0024_Mint.png?v=1724959167"
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0024_Mint.png?v=1724959167",
								"layer": 1,
								"thumbnail": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0024_Mint.png?v=1724959167"
							}
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"allowDiscount": false,
						"discountPrice": 0,
						"disabled": ko.observable(false)
					},
					{
						"sku": "852W",
						"label": "White",
						"reviewLabel": "White Cruiser eBike",
						"code": "white",
						"variantId": 49721295372561,
						"price": 1399.00,
						"swatch": "#F2F2F2",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0022_White.png?v=1724959167",
								"layer": 1,
								"thumbnail": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0022_White.png?v=1724959167"
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0022_White.png?v=1724959167",
								"layer": 1,
								"thumbnail": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0022_White.png?v=1724959167"
							}
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"allowDiscount": false,
						"discountPrice": 0,
						"disabled": ko.observable(false)
					}
				]
			},
			{
				"optionLabel": "Kid Carriers",
				"sectionLabel": "Kid & Pet Carriers",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/880/carriers-new.png",
				"customizeNote": "Add kid & pet carrier accessories to create the perfect ride for your crew.",
				"sectionSelect": ko.observable(false),
				"optionCode": "carriers",
				"prevSec": "color",
				"nextSec": "cargo",
				"type": "checkbox",
				"showOnlyLatest": true,
				"optionItems": [
					{
						"sku": "AC807CRBK",
						"label": "Kid & Cargo™ Carrier - 1 Kid",
						"code": "kid-cargo-carrier-1-kid",
						"variantId": 49948012413201,
						"description": "Ultimate versatility: travel with 1 kid passenger ages 5-10 years or haul up to 65 lbs.",
						"price": 199.00,
						"link": "kid-cargo-carrier-black-1-kid?variant=49948012413201",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0002_AC807BK.png?v=1724959165",
								"layer": 2
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0002_AC807BK.png?v=1724959165",
								"layer": 2
							}
						},
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-AC807-right.png?v=1723650677",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC807BK-bottom.png?v=1723647714",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 129,
						"latestGrouping": "rear"
					},
					{
						"sku": "AC865",
						"label": "Wag 'N Ride Pet Carrier",
						"code": "wag-n-ride-pet-carrier",
						"variantId": 50135024533777,
						"description": "For pets up to 30 lbs. Feature removable top, 4 mesh windows, and adjustable leash.",
						"price": 149.00,
						"link": "wag-n-ride-pet-carrier",
						"displayImages": {
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0000_AC865BK.png?v=1724959167",
								"layer": 7
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0000_AC865BK.png?v=1724959167",
								"layer": 7
							}
						},
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC865-right.png?v=1723738465",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC865BK-AC807BK-bottom.png?v=1723647715",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"maxQty": 2,
						"selected": ko.observable(false),
						"required": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 49,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					},
					{
						"sku": "AC806CRBK",
						"label": "Kid Carrier",
						"code": "kid-carrier-black",
						"variantId": 50169617252625,
						"description": "Bring 1 kid passenger ages 5-10 years old along for the ride with this comfortable kid carrier seat.",
						"price": 149.00,
						"link": "kid-carrier-black?variant=50169617252625",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0008_AC806BK.png?v=1724959166",
								"layer": 2
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0008_AC806BK.png?v=1724959166",
								"layer": 2
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/860/inset-kid-carrier.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-kid-carrier.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 99,
						"latestGrouping": "rear"
					},
					{
						"sku": "AC844",
						"label": "Thule<sup>&reg;</sup> Yepp Nexxt 2 Maxi Child Seat",
						"code": "thule-yepp-nexxt-2-maxi-seat",
						"variantId": 47613239755025,
						"description": "Transport passengers ages 9 months to 6 years old, up to 40 lbs.",
						"price": 279.95,
						"link": "thule-yepp-nexxt-2-maxi-seat",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0005_AC844-REND.png?v=1724959166",
								"layer": 2
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0005_AC844-REND.png?v=1724959166",
								"layer": 2
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-thule-yepp-nexxt-child-seat.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-thule-yepp-nexxt-child-seat.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"latestGrouping": "rear"
					},
					{
						"sku": "822Z",
						"label": "Flyer™ Duoflex",
						"code": "flyer-duoflex",
						"variantId": 47317443019025,
						"description": "From roll to stroll, the Flyer™ Duoflex is the ultimate bike trailer and double stroller for on-the-go families.",
						"price": 429.00,
						"link": "flyer-duoflex",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-flyer-duoflex.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-flyer-duoflex.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					},
				]
			},
			{
				"optionLabel": "Cargo Storage",
				"sectionLabel": "Cargo Storage",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/852/cargo-storage.png",
				"customizeNote": "Choose the storage solution that is right for you by selecting from our assortment of cargo accessories.",
				"sectionSelect": ko.observable(false),
				"prevSec": "carriers",
				"nextSec": "Safety",
				"optionCode": "cargo",
				"type": "checkbox",
				"showOnlyLatest": true,
				"optionItems": [
					{
						"sku": "AC837",
						"label": "Quick Release Woven Basket",
						"code": "woven-front-basket",
						"variantId": 47317410873617,
						"description": "Stylish front storage for your Cruiser. Features a carry handle and tool-free quick disconnect for easy loading and transport. Holds up to 11 lbs.",
						"price": 99.00,
						"link": "quick-release-handlebar-woven-basket",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0017_AC837-Wicker-Basket.png?v=1724959166",
								"layer": 7
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0017_AC837-Wicker-Basket.png?v=1724959166",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/851/inset-front-woven.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-front-woven.png",
						"allowQty": false,
						"latest": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": true,
						"discountPrice": 0,
						"latestGrouping": "front"
					},
					{
						"sku": "AC836",
						"label": "Quick Release Wire Basket",
						"code": "wire-front-basket",
						"variantId": 47317411365137,
						"description": "Stainless-steel front storage for your Cruiser. Features a carry handle and tool-free quick disconnect for easy loading and transport. Holds up to 11 lbs.",
						"price": 99.00,
						"link": "quick-release-handlebar-wire-basket",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0016_AC836-Wire-Basket.png?v=1724959166",
								"layer": 7
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0016_AC836-Wire-Basket.png?v=1724959166",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/851/inset-front-wire.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-front-wire.png",
						"allowQty": false,
						"latest": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"latestGrouping": "front"
					},
					{
						"sku": "AC801BK",
						"label": "Front Storage Basket",
						"code": "front-storage-basket-black",
						"variantId": 48712895136017,
						"description": "Holds up to 25 lbs. Made with 100% recycled fabric. ",
						"notes": "",
						"price": 129.00,
						"link": "front-storage-basket-black",
						"displayImages": {
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0020_AC801BK.png?v=1724959166",
								"layer": 7
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0020_AC801BK.png?v=1724959166",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-front-storage-bk-new.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-front-storage-bk.png",
						"allowQty": false,
						"latest": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"grouping": "small-front",
						"latestGrouping": "front"
					},
					{
						"sku": "AC805BK",
						"label": "Front Rack",
						"code": "rack",
						"variantId": 48712883732753,
						"description": "Provides versatility & expands your hauling capacity. Holds up to 30 lbs",
						"price": 99.00,
						"link": "front-rack-black",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0019_AC805BK.png?v=1724959166",
								"layer": 7
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0019_AC805BK.png?v=1724959166",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-front-rack-bk.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-front-rack-bk.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 39,
						"latest": false,
						"latestGrouping": "front"
					},
					{
						"sku": "AC869",
						"label": "36L Soft Cooler",
						"code": "36l-soft-cooler",
						"variantId": 50940682076433,
						"description": "Perfect for traveling & on-the-go adventures. Insulated, durable, and waterproof. Holds up to 80 lbs.",
						"price": 149.00,
						"link": "36l-soft-cooler",
						"displayImages": {
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/852/AC869.png",
								"layer": 8
							},
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/852/AC869.png",
								"layer": 8
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/ac869-cooler.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/ac869-cooler.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 49,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					},
					{
						"sku": "AC808",
						"label": "Carry & Go Tote Bag",
						"code": "carry-go-tote",
						"variantId": 48712879309073,
						"description": "Holds up to 60 lbs. and features internal zipper pocket. Folds flat on bike. Made with 100% recycled fabric.",
						"price": 69.00,
						"link": "carry-go-tote-bag",
						"displayImages": {
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0001_AC808BK.png?v=1724959166",
								"layer": 7
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0001_AC808BK.png?v=1724959166",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-carry-go-tote.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-carry-go-tote.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"maxQty": 2,
						"selected": ko.observable(false),
						"required": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 49,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					},
					{
						"sku": "AC862",
						"label": "Rear Woven Storage Basket",
						"code": "rear-storage-woven-basket",
						"variantId": 49222831374609,
						"description": "Holds up to 30 lbs. Great for small bags, purses, & personal items.",
						"price": 119.00,
						"link": "rear-woven-storage-basket",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0004_AC862-Wicker-Basket.png?v=1724959166",
								"layer": 7
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0004_AC862-Wicker-Basket.png?v=1724959166",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-ac862.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-ac862.png",
						"allowQty": false,
						"latest": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": true,
						"discountPrice": 0,
						"latestGrouping": "rear"
					},
					{
						"sku": "AC861",
						"label": "Rear Wire Storage Basket",
						"code": "rear-wire-storage-basket",
						"variantId": 49222834487569,
						"description": "Holds up to 30 lbs. Great for small bags, purses, & personal items.",
						"price": 119.00,
						"link": "rear-wire-storage-basket",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0003_AC861-Wire-Basket.png?v=1724959165",
								"layer": 8
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0003_AC861-Wire-Basket.png?v=1724959165",
								"layer": 8
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-ac861.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-ac861.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 49,
						"latestGrouping": "rear"
					},
					{
						"sku": "AC802BK",
						"label": "Small Rear Storage Basket",
						"code": "small-rear-storage-basket",
						"variantId": 48712887861521,
						"description": "Holds up to 50 lbs. Great for small bags, purses, & personal items.",
						"price": 129.00,
						"link": "rear-storage-basket-black-small",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0021_AC802BK.png?v=1724959166",
								"layer": 8
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0021_AC802BK.png?v=1724959166",
								"layer": 8
							}
						},
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC802BK-right.png?v=1723652171",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC802BK-Bottom.png?v=1723652171",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 49,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					},
					/* {
						"sku": "AC842BK",
						"label": "Waterproof Rear Storage Case & Basket",
						"code": "wp-rear-storage-case",
						"variantId": 50138812154129,
						"description": "Waterproof case holds up to 50 lbs. Securely attaches to the frame of the Flyer™ Rear Storage Basket (Rear Storage Basket included).",
						"price": 238.00,
						"link": "waterproof-rear-storage-case-basket-black-bundle",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0009_AC802_AC842.png?v=1724959166",
								"layer": 7
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0009_AC802_AC842.png?v=1724959166",
								"layer": 7
							}
						},
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC842-right.png?v=1723647715",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC841-bottom.png?v=1723647714",
						"allowQty": false,
						"latest": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 129,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					}, */
					{
						"sku": "AC847",
						"label": "Waterproof Frame Storage Case ",
						"code": "waterproof-frame-storage-case",
						"variantId": 47317479784721,
						"description": "Waterproof storage. Holds up to 6 lbs. Great for keys, wallets, and phones.",
						"price": 34.00,
						"link": "waterproof-frame-storage-case",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0006_AC847.png?v=1724959165",
								"layer": 8
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0006_AC847.png?v=1724959165",
								"layer": 8
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/ac847-right-side.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/ac847-shown-on-bike.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
					},
					{
						"sku": "AC874",
						"label": "Catch-All Bag",
						"code": "catch-all",
						"variantId": 50582958965009,
						"description": "Convenient on-the-go storage. Holds a 32 oz. water bottle or up to 6 lbs. Great for phones, keys, or snacks. Features external mesh pocket and Velcro straps for secure attachment.",
						"notes": "",
						"price": 15.00,
						"link": "catch-all-bag",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/852/catch-all.png",
								"layer": 10
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/852/catch-all.png",
								"layer": 10
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-catch-all.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-ac874.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"required": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
					},
					{
						"sku": "AC846",
						"label": "Waterproof Pannier Bag",
						"code": "wp-pannier-bag",
						"variantId": 47317469528337,
						"description": "Waterproof storage. Holds up to 25 lbs. Quick disconnect for easy on & off.",
						"price": 149.00,
						"link": "waterproof-pannier-bag",
						"displayImages": {
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0007_AC846-pannier.png?v=1724959166",
								"layer": 7
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0007_AC846-pannier.png?v=1724959166",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-pannier.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/shown-on-bike-pannier.png",
						"allowQty": true,
						"latest": false,
						"currQty": ko.observable(1),
						"maxQty": 2,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"latestGrouping": "rear"
					},
					{
						"sku": "AC834",
						"label": "Cargo Straps (2 Pack)",
						"code": "cargo-straps",
						"variantId": 47317447278865,
						"description": "Secure your belongings on the go. Durable, stretchable material. Pack includes 2 straps.",
						"price": 10.00,
						"link": "cargo-straps",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-cargo-straps.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-cargo-straps.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC835",
						"label": "Cargo Net",
						"code": "cargo-net",
						"variantId": 47317448032529,
						"description": "Secure your belongings on the go. Durable, stretchable material.",
						"price": 10.00,
						"link": "cargo-net",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-cargo-net.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-cargo-net.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					}

				]
			},
			{
				"optionLabel": "Safety & Security",
				"sectionLabel": "Safety & Security",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/880/safe-secure.png?d=628",
				"customizeNote": "Explore accessories designed to keep you and your passengers safe and your bike secure.",
				"sectionSelect": ko.observable(false),
				"prevSec": "cargo",
				"nextSec": "rider-extras",
				"optionCode": "Safety",
				"type": "checkbox",
				"showOnlyLatest": false,
				"optionItems": [
					{
						"sku": "AC827",
						"label": "Bar End Bike Mirror",
						"code": "rear-view-mirror",
						"variantId": 47317351203089,
						"description": "Blindspot coverage while you ride. Splash and crack resistant.",
						"price": 39.00,
						"link": "bar-end-bike-mirror",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/860/AC827.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-side-mirror.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0015_AC827.png?v=1724959165",
								"layer": 8
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0015_AC827.png?v=1724959165",
								"layer": 8
							}
						}
					}, {
						"sku": "AC855 ",
						"label": "Kryptonite® Evolution 1090 Integrated",
						"code": "lock",
						"variantId": 47317319418129,
						"description": "High security 3’ heavy duty chain lock",
						"price": 120.95,
						"link": "kryptonite-evolution-1090",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-1090.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-1090.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC856  ",
						"label": "Kryptonite® KryptoLok 610 S Folding Lock ",
						"code": "lock",
						"variantId": 47317319647505,
						"description": "Moderate security compact folding lock",
						"price": 142.95,
						"link": "kryptonite-kryptolok-610",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-610.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-610.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC857 ",
						"label": "Kryptonite® Evolution Standard U Lock",
						"code": "lock",
						"variantId": 47317319909649,
						"description": "High security 14 mm steel U-lock",
						"price": 129.95,
						"link": "kryptonite-evolution-standard-u-lock",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-evolution.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-evolution.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC858",
						"label": "Kryptonite® KryptoLok Standard U",
						"code": "lock",
						"variantId": 47317320073489,
						"description": "Moderate security 12.7 mm steel U-lock",
						"price": 72.95,
						"link": "kryptonite-kryptolok-standard-u-lock",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-krypto.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-krypto.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC859",
						"label": "Kryptonite® KryptoFlex 710 Double Loop Cable ",
						"code": "lock",
						"variantId": 47317320368401,
						"description": "7’ cable to secure front wheel when used with a Kryptonite® lock. Please note this is a cable only (not a lock).",
						"price": 26.95,
						"link": "kryptonite-kryptoflex-710-cable",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-710.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-710.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC818",
						"label": "Bern® Hudson Adult Helmet",
						"code": "bern-hudson-adult-helmet",
						"description": "The optimal combination of style, comfort, and protection.",
						"price": 159.00,
						"link": "bern-hudson-adult-helmet",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/ac818-img-hero.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/ac818-img-cart-small.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": true,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"options": [
							{
								"sku": "S",
								"code": "small",
								"variantId": 47317277245713,
								"label": "Small",
								"selected": ko.observable(false)
							},
							/*{
								"sku": "M",
								"code": "medium",
								"variantId": 47317277475089,
								"label": "Medium",
								"selected": ko.observable(true)
							},*/
							{
								"sku": "L",
								"code": "large",
								"variantId": 47317277606161,
								"label": "Large",
								"selected": ko.observable(true)
							}
						]
					},
					{
						"sku": "AC876BK",
						"label": "Bern® Nino DVRT Youth Helmet, Black",
						"code": "bern-nino-dvrt-youth-helmet-black",
						"description": "Safe, stylish, and designed for a quick and easy fit for young riders.",
						"price": 79.00,
						"link": "bern-nino-dvrt-youth-helmet-black",
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2.png",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": true,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"options": [
							{
								"sku": "XS/S",
								"code": "small",
								"variantId": 50030924955921,
								"label": "Small",
								"selected": ko.observable(false)
							},
							{
								"sku": "S/M",
								"code": "medium",
								"variantId": 50030924988689,
								"label": "Medium",
								"selected": ko.observable(true)
							} 
						]
					},
					{
						"sku": "AC876BL",
						"label": "Bern® Nino DVRT Youth Helmet, Blue",
						"code": "bern-nino-dvrt-youth-helmet-blue",
						"description": "Safe, stylish, and designed for a quick and easy fit for young riders.",
						"price": 79.00,
						"link": "bern-nino-dvrt-youth-helmet-blue",
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2-blue.png",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2-blue.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": true,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"options": [
							{
								"sku": "XS/S",
								"code": "small",
								"variantId": 50030906835217,
								"label": "Small",
								"selected": ko.observable(false)
							},
							{
								"sku": "S/M",
								"code": "medium",
								"variantId": 50030906867985,
								"label": "Medium",
								"selected": ko.observable(true)
							}
						]
					}]
			},
			{
				"optionLabel": "Rider Extras",
				"sectionLabel": "Rider Extras",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/880/rider-extra.png",
				"customizeNote": "Load your electric bike with all of the accessories you need for a comfortable ride.",
				"sectionSelect": ko.observable(false),
				"optionCode": "rider-extras",
				"prevSec": "Safety",
				"nextSec": "review",
				"type": "checkbox",
				"showOnlyLatest": false,
				"optionItems": [
					{
						"sku": "AC848",
						"label": "Waterproof Bike Cover",
						"code": "waterproof-bike-cover",
						"variantId": 49941773451537,
						"description": "Protect your bike from the elements.",
						"price": 64.00,
						"link": "waterproof-bike-cover",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-waterproof-bike-cover.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-waterproof-bike-cover.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC867",
						"label": "Spare Battery",
						"code": "spare-battery-cruisers-folding-cargo",
						"variantId": 47952103506193,
						"description": "Extend ride time with a spare bike battery – charge one while you ride with the other.",
						"price": 399.00,
						"link": "spare-battery-cruisers-folding-cargo",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-ac867.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-ac867.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC822",
						"label": "Cell Phone Mount",
						"code": "cell-phone-mount",
						"variantId": 47317263417617,
						"description": "Secure your phone while you ride. Compatible with phones 3.5”-6.5''",
						"price": 29.00,
						"link": "",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-cell-phone.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-cell-phone.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowOptionsWithImages": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0014_AC822.png?v=1724959165",
								"layer": 8
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/852-Build-8_0014_AC822.png?v=1724959165",
								"layer": 8
							}
						}
					},
					{
						"sku": "AC828",
						"label": "Water Bottle Cage",
						"code": "water-bottle-cage",
						"description": "Holds any standard-sized water bottle. Quick release for easy access.",
						"price": 19.00,
						"link": "",
						"optionImage": {
							"black": "https://images.radioflyer.com/media/flyer/build/860/AC828B.png",
							"silver": "https://images.radioflyer.com/media/flyer/build/860/AC828S.png"
						},
						"cartImage": {
							"black": "https://images.radioflyer.com/media/flyer/build/cart-water-cage-black.png",
							"silver": "https://images.radioflyer.com/media/flyer/build/cart-water-cage-silver.png",
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"imageOption": ko.observable('black'),
						"allowOptions": true,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"displayImages": {
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/851/{OPTION}-water-cage.png?d=119",
								"layer": 8
							},
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/851/{OPTION}-water-cage-hero.png",
								"layer": 8
							}
						},
						"options": [
							{
								"sku": "B",
								"swatch": "black",
								"code": "black",
								"variantId": 47317354938641,
								"label": "Black",
								"selected": ko.observable(true)
							},
							{
								"sku": "S",
								"swatch": "#d9d9db",
								"code": "silver",
								"variantId": 47317355626769,
								"label": "Silver",
								"selected": ko.observable(false)
							}
						]
					},
					{
						"sku": "AC824",
						"label": "Water Bottle",
						"code": "water-bottle",
						"variantId": 47317264466193,
						"description": "Hydrate on the go with this BPA free 20 oz. water bottle.",
						"price": 14.00,
						"link": "",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-water-bottle-860.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-water-bottle-860.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					}, 
					{
						"sku": "AC838",
						"label": "Battery & Charger Holder",
						"code": "water-bottle",
						"variantId": 47317512552721,
						"description": "Secure storage for your Flyer™ eBike battery & charger.",
						"price": 49.00,
						"link": "battery-charger-holder",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-ac838.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-ac838.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					}
				]
			}


		]
	},
	"FLYER-884": {
		"title": "Flyer<sup>&trade;</sup> Via",
		"options": [
			{
				"optionLabel": "Color",
				"sectionLabel": "Frame Size & Color",
				"noSize": false,
				"sectionImg": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/884-IMG-Hero-Profile-Yellow_eb3595c7-687b-46c5-9c08-2ecf84c9bf2f.jpg?v=1724159580",
				"customizeNote": "Find your perfect fit by selecting one of three frame sizes and customize with your choice of color.",
				"sectionSelect": ko.observable(false),
				"optionCode": "color",
				"type": "radio",
				"selectedOption": ko.observable(),
				"optionItems": [
					{
						"sku": "884BK",
						"label": "Black",
						"reviewLabel": "Black 884",
						"code": "black",
						"price": 2699.00,
						"swatch": "#000000",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/bike-black.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/884/profile-black.png?d=42022"
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/bike-black.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/884/hero-black.png?d=42022"
							}
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"allowDiscount": false,
						"discountPrice": 0,
						"disabled": ko.observable(false)
					},
					{
						"sku": "884G",
						"label": "Sage Green",
						"reviewLabel": "Sage Green 884",
						"code": "green",
						"price": 2699.00,
						"swatch": "#B7BAA9",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/bike-green.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/884/profile-red.png?d=42022"
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/bike-green.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/884/hero-red.png?d=42022"
							}
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"allowDiscount": false,
						"discountPrice": 0,
						"disabled": ko.observable(false)
					},
					{
						"sku": "884Y",
						"label": "School Bus Yellow",
						"reviewLabel": "School Bus Yellow 884",
						"code": "yellow",
						"price": 2699.00,
						"swatch": "#FBAC24",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/bike-yellow.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/884/profile-white.png?d=42022"
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/bike-yellow.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/884/hero-white.png?d=42022"
							}
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"allowDiscount": false,
						"discountPrice": 0,
						"disabled": ko.observable(false)
					}
				]
			},
			{
				"optionLabel": "Frame Size",
				"optionCode": "size",
				"extBattery": false,
				"type": "radio",
				"sectionLabel": "",
				"customizeNote": "",
				"sectionSelect": ko.observable(false),
				"nextSec": "carriers",
				"selectedOption": ko.observable(),
				"optionItems": [
					{
						"sku": "S",
						"label": "4'10'' - 5'10''",
						"reviewLabel": "Small Frame Size (4'10'' - 5'10'')",
						"code": "small",
						"price": 0.00,
						"swatch": "Small",
						"allowQty": false,
						"currQty": ko.observable(1),
						"disabled": ko.observable(false)
					},
					{
						"sku": "M",
						"label": "5'3'' - 6'3''",
						"reviewLabel": "Medium Frame Size (5'3'' - 6'3'')",
						"code": "medium",
						"price": 0.00,
						"swatch": "Medium",
						"allowQty": false,
						"currQty": ko.observable(1),
						"disabled": ko.observable(false)
					},
					{
						"sku": "L",
						"label": "5'10'' - 6'10''",
						"reviewLabel": "Large Frame Size (5'10'' - 6'10'')",
						"code": "large",
						"price": 0.00,
						"swatch": "Large",
						"allowQty": false,
						"currQty": ko.observable(1),
						"disabled": ko.observable(false)
					}
				]
			},
	// 		{
	// 			"optionLabel": "Popular Accessory Combos",
	// 			"sectionLabel": "Popular Accessory Combos",
	// 			"sectionImg": "https://images.radioflyer.com/media/flyer/build/884/menu-bundles-884.png",
	// 			"customizeNote": "Create the perfect ride for your crew with our extensive accessory system. Get started with one of our recommended accessory sets. ",
	// 			"sectionSelect": ko.observable(false),
	// 			"prevSec": "color",
	// 			"nextSec": "carriers",
	// 			"optionCode": "favorites",
	// 			"type": "checkbox",
	// 			"showOnlyLatest": false,
	// 			"optionItems": [
	// 			{
	// 					"sku": "1",
	// 					"label": "All Weather Riding",
	// 					"code": "all-weather",
	// 					"bundleCode": "weather",
	// 					"variantId": 48712864989457,
	// 					"description": "Protect little riders from the elements",
	// 					"bundleDescription": "Includes the Kid & Cargo™ Canopy and Kid & Cargo™ Carrier XL Hauler",
	// 					"price": 0,
	// 					"fakePrice": 348.00,
	// 					"link": "",
	// 					"optionImage": "https://images.radioflyer.com/media/flyer/build/884/all-weather.png",
	// 					"cartImage": "",
	// 					"allowQty": false,
	// 					"currQty": ko.observable(1),
	// 					"selected": ko.observable(false),
	// 					"allowOptions": false,
	// 					"allowDiscount": false,
	// 					"discountPrice": 129,
	// 			},
	// 			{
	// 				"sku": "2",
	// 				"label": "Grocery Workhorse",
	// 				"code": "all-weather",
	// 				"bundleCode": "grocery",
	// 				"variantId": 48712864989457,
	// 				"description": "For versatile cargo carrying",
	// 				"bundleDescription": "Includes two Carry & Go Tote Bags",
	// 				"price": 0,
	// 				"fakePrice": 138.00,
	// 				"link": "",
	// 				"optionImage": "https://images.radioflyer.com/media/flyer/build/884/grocery.png",
	// 				"cartImage": "",
	// 				"allowQty": false,
	// 				"currQty": ko.observable(1),
	// 				"selected": ko.observable(false),
	// 				"allowOptions": false,
	// 				"allowDiscount": false,
	// 				"discountPrice": 129,
	// 		},
	// 	// 	{
	// 	// 		"sku": "3",
	// 	// 		"label": "Kid & Cargo Duo",
	// 	// 		"code": "all-weather",
	// 	// 		"bundleCode": "cargo",
	// 	// 		"variantId": 48712864989457,
	// 	// 		"description": "The best of both worlds",
	// 	// 		"bundleDescription": "Includes one Carry & Go Tote Bag and the Thule® Yepp Nexxt 2 Maxi Seat",
	// 	// 		"price": 0,
	// 	// 		"fakePrice": 318.95,
	// 	// 		"link": "",
	// 	// 		"optionImage": "https://images.radioflyer.com/media/flyer/build/884/cargo.png",
	// 	// 		"cartImage": "",
	// 	// 		"allowQty": false,
	// 	// 		"currQty": ko.observable(1),
	// 	// 		"selected": ko.observable(false),
	// 	// 		"allowOptions": false,
	// 	// 		"allowDiscount": false,
	// 	// 		"discountPrice": 129,
	// 	// },
	// 	{
	// 		"sku": "4",
	// 		"label": "School Bus Hauling",
	// 		"code": "all-weather",
	// 		"bundleCode": "school",
	// 		"variantId": 48712864989457,
	// 		"description": "The ultimate kid carrying accessory",
	// 		"bundleDescription": "Includes the Kid & Cargo™ Carrier XL Hauler",
	// 		"price": 0,
	// 		"fakePrice": 149.00,
	// 		"link": "",
	// 		"optionImage": "https://images.radioflyer.com/media/flyer/build/884/school.png",
	// 		"cartImage": "",
	// 		"allowQty": false,
	// 		"currQty": ko.observable(1),
	// 		"selected": ko.observable(false),
	// 		"allowOptions": false,
	// 		"allowDiscount": false,
	// 		"discountPrice": 129,
	// },

	// 			]
	// 		},
			{
				"optionLabel": "Kid Carrying Accessories",
				"sectionLabel": "Kid & Pet Carriers",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/884/carriers.png",
				"customizeNote": "Add kid & pet carrier accessories to create the perfect ride for your crew.",
				"sectionSelect": ko.observable(false),
				"prevSec": "color",
				"nextSec": "cargo",
				"optionCode": "carriers",
				"type": "checkbox",
				"showOnlyLatest": true,
				"optionItems": [
				{
						"sku": "AC814",
						"label": "Kid & Cargo Carrier",
						"code": "kid-and-cargo-carrier-via",
						"variantId": 49721228493073,
						"description": "Carry two child riders or haul cargo.",
						"price": 199.00,
						"link": "kid-cargo-carrier-hoop-2-kids",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/kid-and-cargo-carrier.png",
								"layer": 1
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/kid-and-cargo-carrier.png",
								"layer": 1
							}
						},
						"optionImage": "https://cdn.shopify.com/s/files/1/0776/3404/4189/files/884-886-AC814-right.jpg?v=1724177350",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC814-Bottom.png?v=1723647714",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"latestGrouping": "rear"
					},
					{
						"sku": "AC865",
						"label": "Wag 'N Ride Pet Carrier",
						"code": "wag-n-ride-pet-carrier",
						"variantId": 50135024533777,
						"description": "For pets up to 30 lbs. Feature removable top, 4 mesh windows, and adjustable leash.",
						"price": 149.00,
						"link": "wag-n-ride-pet-carrier",
						"displayImages": {
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/884-BUILD-AC865BK-AC814BK.png?v=1724252793",
								"layer": 7
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/884-BUILD-AC865BK-AC814BK.png?v=1724252793",
								"layer": 7
							}
						},
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC865BK-AC807BK-right.png?v=1723647714",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC865BK-AC807BK-bottom.png?v=1723647715",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"maxQty": 2,
						"selected": ko.observable(false),
						"required": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 49,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					},
					{
						"sku": "AC809",
						"label": "Kid & Cargo Carrier XL Hauler",
						"code": "kid-and-cargo-carrier-XL",
						"variantId": 48712875966737,
						"description": "For all weather riding and expanded storage capacity. Zipper side door for easy passenger in and out. Holds up to 150 lbs. Made with 100% recycled fabric.",
						"price": 149.00,
						"link": "kid-cargo-carrier-xl-hauler",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/{OPTION}-kid-and-cargo-carrier-xl.png",
								"layer": 10
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/{OPTION}-kid-and-cargo-carrier-xl.png",
								"layer": 10
							}
						},
						"optionImage": {
							"grey": "https://images.radioflyer.com/media/flyer/build/inset-kid-and-cargo-carrier-xl.png",
							"red": "https://images.radioflyer.com/media/flyer/build/inset-kid-cargo-carrier-xl-red.png"
						},
						"cartImage": {
							"grey": "https://images.radioflyer.com/media/flyer/build/cart-kid-and-cargo-carrier-xl.png",
							"red": "https://images.radioflyer.com/media/flyer/build/cart-kid-cargo-carrier-xl-red.png",
						},
						
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"imageOption": ko.observable('grey'),
						"allowOptions": true,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"required": ko.observable(false),
						"latestGrouping": "rear",
						"options": [
							{
								"sku": "",
								"swatch": "grey",
								"code": "grey",
								"variantId": 50582937141521,
								"label": "Grey",
								"selected": ko.observable(true)
							},
							{
								"sku": "R",
								"swatch": "#c71c2d",
								"code": "red",
								"variantId": 50582937174289,
								"label": "Red",
								"selected": ko.observable(false)
							}
						]
					},
					{
						"sku": "AC839",
						"label": "Kid & Cargo Carrier Cover",
						"code": "kid-cargo-carrier-cover",
						"variantId": 48712864989457,
						"description": "Keeps your items dry on the go. Made with 100% recycled fabric.",
						"price": 39.00,
						"link": "kid-cargo-carrier-cover",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-kid-cargo-carrier-cover.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-kid-cargo-carrier-cover.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 129,
					},
					{
						"sku": "AC815",
						"label": "Kid & Cargo Carrier Canopy",
						"code": "kid-and-cargo-carrier-canopy",
						"variantId": 48712872165649,
						"description": "Protective, high-visibility canopy for all weather riding.",
						"notes": "",
						"price": 199.00,
						"link": "kid-cargo-canopy",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/kid-and-cargo-canopy.png",
								"layer": 10
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/kid-and-cargo-canopy.png",
								"layer": 10
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-kid-and-cargo-canopy.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-kid-and-cargo-canopy.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"required": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"latestGrouping": "rear"
					},
					{
						"sku": "822Z",
						"label": "Flyer™ Duoflex",
						"code": "flyer-duoflex",
						"variantId": 47317443019025,
						"description": "From roll to stroll, the Flyer™ Duoflex is the ultimate bike trailer and double stroller for on-the-go families.",
						"price": 429.00,
						"link": "flyer-duoflex",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-flyer-duoflex.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-flyer-duoflex.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"discountPrice": 0,
						"allowDiscount": false
					},
					{
						"sku": "AC844",
						"label": "Thule Yepp Nexxt 2 Maxi Seat",
						"code": "thule-yepp-maxi-2-seat",
						"variantId": 47613239755025,
						"description": "For all weather riding and expanded storage capacity. Zipper side door for easy passenger in and out. Holds up to 150 lbs. Made with 100% recycled fabric.",
						"price": 279.95,
						"link": "thule-yepp-nexxt-2-maxi-seat",
						"latest": false,
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-thule-yepp-nexxt-child-seat.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-thule-yepp-nexxt-child-seat.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 2,
						"selected": ko.observable(false),
						"required": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"latestGrouping": "rear",
						"displayImages": {
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/Thule-Single-884.png?v=1724698394",
								"layer": 10
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/Thule-Single-884.png?v=1724698394",
								"layer": 10
							}
						},
					}
				]
			},
			{
				"optionLabel": "Cargo Storage",
				"sectionLabel": "Cargo Storage",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/884/cargo-storage.png",
				"customizeNote": "Choose the storage solution that is right for you by selecting from our assortment of cargo accessories.",
				"sectionSelect": ko.observable(false),
				"prevSec": "carriers",
				"nextSec": "safety",
				"optionCode": "cargo",
				"type": "checkbox",
				"showOnlyLatest": true,
				"optionItems": [
				
					// {
					// 	"sku": "AC841",
					// 	"label": "Waterproof Front Storage Case & Basket",
					// 	"code": "wp-front-storage-case",
					// 	"variantId": 49907988529425,
					// 	"description": "Waterproof case holds up to 25 lbs. Securely attaches to the frame of the Flyer™ Front Storage Basket (Front Storage Basket included).",
					// 	"price": 228.00,
					// 	"link": "waterproof-front-storage-case-basket-black-bundle",
					// 	"displayImages": {
					// 		"hero": {
					// 			"image": "https://images.radioflyer.com/media/flyer/build/884/front-storage-basket-waterproof.png",
					// 			"layer": 7
					// 		},
					// 		"profile": {
					// 			"image": "https://images.radioflyer.com/media/flyer/build/884/front-storage-basket-waterproof.png",
					// 			"layer": 7
					// 		}
					// 	},
					// 	"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-front-wp-storage-bk.png",
					// 	"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-front-storage-waterproof.png",
					// 	"allowQty": false,
					// 	"latest": false,
					// 	"currQty": ko.observable(1),
					// 	"selected": ko.observable(false),
					// 	"allowOptions": false,
					// 	"allowDiscount": false,
					// 	"discountPrice": 129,
					// 	"grouping": "small-front",
					// 	"latestGrouping": "front"
					// },

					{
						"sku": "AC801BK",
						"label": "Front Storage Basket",
						"code": "front-storage-basket-black",
						"variantId": 48712895136017,
						"description": "Holds up to 25 lbs. Made with 100% recycled fabric. ",
						"notes": "",
						"price": 129.00,
						"link": "front-storage-basket-black",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/front-storage-basket.png",
								"layer": 7
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/front-storage-basket.png",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-front-storage-bk-new.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-front-storage-bk.png",
						"allowQty": false,
						"latest": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"grouping": "small-front",
						"latestGrouping": "front"
					},
					{
						"sku": "AC805BK ",
						"label": "Front Rack",
						"code": "rack",
						"variantId": 48712883732753,
						"description": "Provides versatility & expands your hauling capacity. Holds up to 30 lbs",
						"price": 99.00,
						"link": "front-rack-black",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/front-rack.png",
								"layer": 7
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/front-rack.png",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-front-rack-bk.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-front-rack-bk.png",
						"allowQty": false,
						"latest": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 39,
						"latestGrouping": "front"
					},
					{
						"sku": "AC869",
						"label": "36L Soft Cooler",
						"code": "36l-soft-cooler",
						"variantId": 50940682076433,
						"description": "Perfect for traveling & on-the-go adventures. Insulated, durable, and waterproof. Holds up to 80 lbs.",
						"price": 149.00,
						"link": "36l-soft-cooler",
						"displayImages": {
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/AC869-{QTY}.png",
								"layer": 8
							},
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/AC869-{QTY}.png",
								"layer": 8
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/ac869-cooler.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/ac869-cooler.png",
						"latest": false,
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 2,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 49,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					},
					{
						"sku": "AC808",
						"label": "Carry & Go Tote Bag",
						"code": "carry-go-tote",
						"variantId": 48712879309073,
						"description": "Holds up to 60 lbs. and features internal zipper pocket. Folds flat on bike. Made with 100% recycled fabric.",
						"price": 69.00,
						"link": "carry-go-tote-bag",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/carry-go-tote-{QTY}.png",
								"layer": 8
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/carry-go-tote-{QTY}.png",
								"layer": 8
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-carry-go-tote.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-carry-go-tote.png",
						"latest": false,
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 2,
						"selected": ko.observable(false),
						"required": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 49,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					},
					
					{
						"sku": "AC847",
						"label": "Waterproof Frame Storage Case",
						"code": "wp-frame-storage-bag",
						"variantId": 47317479784721,
						"description": "Waterproof storage. Holds up to 6 lbs. Great for keys, wallets, and phones.",
						"price": 34.00,
						"link": "waterproof-frame-storage-case",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/frame-storage-waterproof.png",
								"layer": 9
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/frame-storage-waterproof.png",
								"layer": 9
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-frame-storage-847.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-frame-storage-waterproof.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC874",
						"label": "Catch-All Bag",
						"code": "catch-all",
						"variantId": 50582958965009,
						"description": "Convenient on-the-go storage. Holds a 32 oz. water bottle or up to 6 lbs. Great for phones, keys, or snacks. Features external mesh pocket and Velcro straps for secure attachment.",
						"notes": "",
						"price": 15.00,
						"link": "catch-all-bag",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/catch-all.png",
								"layer": 10
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/catch-all.png",
								"layer": 10
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-catch-all.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-ac874.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"required": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
					},
					{
						"sku": "AC846",
						"label": "Waterproof Pannier Bag",
						"code": "wp-pannier-bag",
						"variantId": 47317469528337,
						"description": "Waterproof storage. Holds up to 25 lbs. Quick disconnect for easy on & off.",
						"price": 149.00,
						"link": "waterproof-pannier-bag",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/884-pannier.png",
								"layer": 7
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/884-pannier.png",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-pannier-bag.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/shown-on-bike-pannier.png",
						"allowQty": true,
						"latest": false,
						"currQty": ko.observable(1),
						"maxQty": 2,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"latestGrouping": "rear"
					},
					{
						"sku": "AC834",
						"label": "Cargo Straps (2 Pack)",
						"code": "cargo-straps",
						"variantId": 47317447278865,
						"description": "Secure your belongings on the go. Durable, stretchable material. Pack includes 2 straps.",
						"price": 10.00,
						"link": "cargo-straps",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-cargo-straps.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-cargo-straps.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC835",
						"label": "Cargo Net",
						"code": "cargo-net",
						"variantId": 47317448032529,
						"description": "Secure your belongings on the go. Durable, stretchable material.",
						"price": 10.00,
						"link": "cargo-net",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-cargo-net.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-cargo-net.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					}

				]
			},
			{
				"optionLabel": "Safety & Security",
				"sectionLabel": "Safety & Security",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/885/safe-secure.png?d=628",
				"customizeNote": "Explore accessories designed to keep you and your passengers safe and your bike secure.",
				"sectionSelect": ko.observable(false),
				"prevSec": "cargo",
				"nextSec": "rider-extras",
				"optionCode": "safety",
				"type": "checkbox",
				"showOnlyLatest": false,
				"optionItems": [
				{
						"sku": "AC827",
						"label": "Bar End Bike Mirror",
						"code": "rear-view-mirror",
						"variantId": 47317351203089,
						"description": "Blindspot coverage while you ride. Splash and crack resistant.",
						"price": 39.00,
						"link": "bar-end-bike-mirror",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/860/AC827.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-side-mirror.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"displayImages": {
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/side-mirror.png",
								"layer": 8
							},
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/side-mirror.png",
								"layer": 8
							}
						}
					},
					{
						"sku": "AC855",
						"label": "Kryptonite® Evolution 1090 Integrated",
						"code": "lock",
						"variantId": 47317319418129,
						"description": "High security 3’ heavy duty chain lock",
						"price": 120.95,
						"link": "kryptonite-evolution-1090",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-1090.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-1090.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC856",
						"label": "Kryptonite® KryptoLok 610 S Folding Lock ",
						"code": "lock",
						"variantId": 47317319647505,
						"description": "Moderate security compact folding lock",
						"price": 142.95,
						"link": "kryptonite-kryptolok-610",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-610.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-610.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC857",
						"label": "Kryptonite® Evolution Standard U Lock",
						"code": "lock",
						"variantId": 47317319909649,
						"description": "High security 14 mm steel U-lock",
						"price": 129.95,
						"link": "kryptonite-evolution-standard-u-lock",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-evolution.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-evolution.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC858",
						"label": "Kryptonite® KryptoLok Standard U",
						"code": "lock",
						"variantId": 47317320073489,
						"description": "Moderate security 12.7 mm steel U-lock",
						"price": 72.95,
						"link": "kryptonite-kryptolok-standard-u-lock",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-krypto.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-krypto.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC859",
						"label": "Kryptonite® KryptoFlex 710 Double Loop Cable ",
						"code": "lock",
						"variantId": 47317320368401,
						"description": "7’ cable to secure front wheel when used with a Kryptonite® lock. Please note this is a cable only (not a lock).",
						"price": 26.95,
						"link": "kryptonite-kryptoflex-710-cable",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-710.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-710.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC818",
						"label": "Bern® Hudson Adult Helmet",
						"code": "bern-hudson-adult-helmet",
						"description": "The optimal combination of style, comfort, and protection.",
						"price": 159.00,
						"link": "bern-hudson-adult-helmet",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/ac818-img-hero.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/ac818-img-cart-small.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": true,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"options": [
							{
								"sku": "S",
								"code": "small",
								"variantId": 47317277245713,
								"label": "Small",
								"selected": ko.observable(false)
							},
							/*{
								"sku": "M",
								"code": "medium",
								"variantId": 47317277475089,
								"label": "Medium",
								"selected": ko.observable(true)
							},*/
							{
								"sku": "L",
								"code": "large",
								"variantId": 47317277606161,
								"label": "Large",
								"selected": ko.observable(true)
							}
						]
					},
					{
						"sku": "AC876BK",
						"label": "Bern® Nino DVRT Youth Helmet, Black",
						"code": "bern-nino-dvrt-youth-helmet-black",
						"description": "Safe, stylish, and designed for a quick and easy fit for young riders.",
						"price": 79.00,
						"link": "bern-nino-dvrt-youth-helmet-black",
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2.png",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": true,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"options": [
							{
								"sku": "XS/S",
								"code": "small",
								"variantId": 50030924955921,
								"label": "Small",
								"selected": ko.observable(false)
							},
							{
								"sku": "S/M",
								"code": "medium",
								"variantId": 50030924988689,
								"label": "Medium",
								"selected": ko.observable(true)
							}
						]
					},
					{
						"sku": "AC876BL",
						"label": "Bern® Nino DVRT Youth Helmet, Blue",
						"code": "bern-nino-dvrt-youth-helmet-blue",
						"description": "Safe, stylish, and designed for a quick and easy fit for young riders.",
						"price": 79.00,
						"link": "bern-nino-dvrt-youth-helmet-blue",
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2-blue.png",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2-blue.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": true,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"options": [
							{
								"sku": "XS/S",
								"code": "small",
								"variantId": 50030906835217,
								"label": "Small",
								"selected": ko.observable(false)
							},
							{
								"sku": "S/M",
								"code": "medium",
								"variantId": 50030906867985,
								"label": "Medium",
								"selected": ko.observable(true)
							}
						]
					}
					
				]
			},
			{
				"optionLabel": "Rider Extras",
				"sectionLabel": "Rider Extras",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/885/rider-extra.png",
				"customizeNote": "Load your electric bike with all of the accessories you need for a comfortable ride.",
				"sectionSelect": ko.observable(false),
				"prevSec": "safety",
				"nextSec": "review",
				"optionCode": "rider-extras",
				"type": "checkbox",
				"showOnlyLatest": false,
				"optionItems": [
					{
						"sku": "AC849",
						"label": "Waterproof Bike Cover",
						"code": "waterproof-bike-cover",
						"variantId": 49941773451537,
						"description": "Protect your bike from the elements.",
						"price": 64.00,
						"link": "waterproof-bike-cover",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-waterproof-bike-cover.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-waterproof-bike-cover.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC822",
						"label": "Cell Phone Mount",
						"code": "cell-phone-mount",
						"variantId": 47317263417617,
						"description": "Secure your phone while you ride. Compatible with phones 3.5”-6.5''",
						"price": 29.00,
						"link": "",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-cell-phone.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-cell-phone.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					},{
						"sku": "AC828",
						"label": "Water Bottle Cage",
						"code": "water-bottle-cage",
						"description": "Holds any standard-sized water bottle. Quick release for easy access.",
						"price": 19.00,
						"link": "",
						"optionImage": {
							"black": "https://images.radioflyer.com/media/flyer/build/860/AC828B.png",
							"silver": "https://images.radioflyer.com/media/flyer/build/860/AC828S.png"
						},
						"cartImage": {
							"black": "https://images.radioflyer.com/media/flyer/build/cart-water-cage-black.png",
							"silver": "https://images.radioflyer.com/media/flyer/build/cart-water-cage-silver.png",
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"imageOption": ko.observable('black'),
						"allowOptions": true,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"displayImages": {
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/{OPTION}-water-cage.png?d=119",
								"layer": 8
							},
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/884/{OPTION}-water-cage-hero.png",
								"layer": 8
							}
						},
						"options": [
							{
								"sku": "B",
								"swatch": "black",
								"code": "black",
								"variantId": 47317354938641,
								"label": "Black",
								"selected": ko.observable(true)
							},
							{
								"sku": "S",
								"swatch": "#d9d9db",
								"code": "silver",
								"variantId": 47317355626769,
								"label": "Silver",
								"selected": ko.observable(false)
							}
						]
					},
					{
						"sku": "AC824",
						"label": "Water Bottle",
						"code": "water-bottle",
						"variantId": 47317264466193,
						"description": "Hydrate on the go with this BPA free 20 oz. water bottle.",
						"price": 14.00,
						"link": "",
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/products/water-bottle-model-ac822-shop.jpg",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-water-bottle.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					}, 
					{
						"sku": "AC838",
						"label": "Battery & Charger Holder",
						"code": "water-bottle",
						"variantId": 47317512552721,
						"description": "Secure storage for your Flyer™ eBike battery & charger.",
						"price": 49.00,
						"link": "battery-charger-holder",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-ac838.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-ac838.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					}  /*
					{
						"sku": "AC823",
						"label": "Bike Lock",
						"code": "bike-lock",
						"description": "Secure your bike with confidence. Features a crossbar design, deadbolt with steel shackle, and weatherproof nylon cover for long-lasting protection.",
						"price": 99.99,
						"link": "",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-bike-lock.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-bike-lock.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false
					},
					{
						"sku": "AC820",
						"label": "Bell® Daily MIPS Adult Helmet, Universal Adult",
						"code": "universal-adult-helmet",
						"description": "Comfortable, stylish, and safe – light up your ride with the Bell® Daily MIPS LED Adult Helmet. Fits head size of 54-61 cm. Ships November 2021.",
						"price": 119.00,
						"link": "bell-daily-mips-led-adult-helmet.html",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-adult-helmet.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-adult-helmet.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false
					},
					{
						"sku": "AC819",
						"label": "Bell® Daily MIPS Adult Helmet, Universal Women's",
						"code": "universal-womens-helmet",
						"description": "Comfortable, stylish, and safe – light up your ride with the Bell® Daily MIPS LED Adult Helmet. Fits head size of 50-57 cm. Ships November 2021.",
						"price": 119.00,
						"link": "bell-daily-mips-led-adult-helmet-uw.html",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-adult-helmet.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-adult-helmet.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false
					},*/

				]
			}
		]
	},
	"FLYER-886": {
		"title": "Flyer<sup>&trade;</sup> Via Pro",
		"options": [
			{
				"optionLabel": "Color",
				"sectionLabel": "Color & Size",
				"noSize": false,
				"sectionImg": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/886-IMG-Hero-Profile-Blue_6f24d269-42ea-4f73-a5f6-5048dd7590d0.jpg?v=1724166915",
				"customizeNote": "Find your perfect fit by selecting one of three frame sizes and customize with your choice of color.",
				"sectionSelect": ko.observable(false),
				"optionCode": "color",
				"type": "radio",
				"selectedOption": ko.observable(),
				"optionItems": [
					{
						"sku": "886BK",
						"label": "Black",
						"reviewLabel": "Black 886",
						"code": "black",
						"price": 2899.00,
						"swatch": "#000000",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/bike-black.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/886/profile-red.png?d=42022"
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/bike-black.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/886/hero-red.png?d=42022"
							}
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"allowDiscount": false,
						"discountPrice": 0,
						"disabled": ko.observable(false)
					},
					{
						"sku": "886G",
						"label": "Forest Green",
						"reviewLabel": "Forest Green 886",
						"code": "green",
						"price": 2899.00,
						"swatch": "#233F38",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/bike-green.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/886/profile-red.png?d=42022"
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/bike-green.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/886/hero-red.png?d=42022"
							}
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"allowDiscount": false,
						"discountPrice": 0,
						"disabled": ko.observable(false)
					},
					{
						"sku": "886BL",
						"label": "Space Gray Blue",
						"reviewLabel": "Space Gray Blue 886",
						"code": "blue",
						"price": 2899.00,
						"swatch": "#B2C3C6",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/bike-blue.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/886/profile-white.png?d=42022"
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/bike-blue.png",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/886/hero-white.png?d=42022"
							}
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"allowDiscount": false,
						"discountPrice": 0,
						"disabled": ko.observable(false)
					}
				]
			},
			{
				"optionLabel": "Frame Size",
				"optionCode": "size",
				"extBattery": false,
				"type": "radio",
				"sectionLabel": "",
				"customizeNote": "",
				"sectionSelect": ko.observable(false),
				"nextSec": "carriers",
				"selectedOption": ko.observable(),
				"optionItems": [
					{
						"sku": "S",
						"label": "4'10'' - 5'10''",
						"reviewLabel": "Small Frame Size (4'10'' - 5'10'')",
						"code": "small",
						"price": 0.00,
						"swatch": "Small",
						"allowQty": false,
						"currQty": ko.observable(1),
						"disabled": ko.observable(false)
					},
					{
						"sku": "M",
						"label": "5'3'' - 6'3''",
						"reviewLabel": "Medium Frame Size (5'3'' - 6'3'')",
						"code": "medium",
						"price": 0.00,
						"swatch": "Medium",
						"allowQty": false,
						"currQty": ko.observable(1),
						"disabled": ko.observable(false)
					},
					{
						"sku": "L",
						"label": "5'10'' - 6'10''",
						"reviewLabel": "Large Frame Size (5'10'' - 6'10'')",
						"code": "large",
						"price": 0.00,
						"swatch": "Large",
						"allowQty": false,
						"currQty": ko.observable(1),
						"disabled": ko.observable(false)
					}
				]
			},
	// 		{
	// 			"optionLabel": "Popular Accessory Combos",
	// 			"sectionLabel": "Popular Accessory Combos",
	// 			"sectionImg": "https://images.radioflyer.com/media/flyer/build/886/menu-bundles-886.png",
	// 			"customizeNote": "Create the perfect ride for your crew with our extensive accessory system. Get started with one of our recommended accessory sets. ",
	// 			"sectionSelect": ko.observable(false),
	// 			"prevSec": "color",
	// 			"nextSec": "carriers",
	// 			"optionCode": "favorites",
	// 			"type": "checkbox",
	// 			"showOnlyLatest": false,
	// 			"optionItems": [
	// 				{
	// 					"sku": "1",
	// 					"label": "All Weather Riding",
	// 					"code": "all-weather",
	// 					"bundleCode": "weather",
	// 					"variantId": 48712864989457,
	// 					"description": "Protect little riders from the elements",
	// 					"bundleDescription": "Includes the Kid & Cargo™ Canopy and Kid & Cargo™ Carrier XL Hauler",
	// 					"price": 0,
	// 					"fakePrice": 348.00,
	// 					"link": "",
	// 					"optionImage": "https://images.radioflyer.com/media/flyer/build/886/all-weather.png",
	// 					"cartImage": "",
	// 					"allowQty": false,
	// 					"currQty": ko.observable(1),
	// 					"selected": ko.observable(false),
	// 					"allowOptions": false,
	// 					"allowDiscount": false,
	// 					"discountPrice": 129,
	// 			},
	// 			{
	// 				"sku": "2",
	// 				"label": "Grocery Workhorse",
	// 				"code": "all-weather",
	// 				"bundleCode": "grocery",
	// 				"variantId": 48712864989457,
	// 				"description": "For versatile cargo carrying",
	// 				"bundleDescription": "Includes two Carry & Go Tote Bags",
	// 				"price": 0,
	// 				"fakePrice": 138.00,
	// 				"link": "",
	// 				"optionImage": "https://images.radioflyer.com/media/flyer/build/886/grocery.png",
	// 				"cartImage": "",
	// 				"allowQty": false,
	// 				"currQty": ko.observable(1),
	// 				"selected": ko.observable(false),
	// 				"allowOptions": false,
	// 				"allowDiscount": false,
	// 				"discountPrice": 129,
	// 		},
	// 	// 	{
	// 	// 		"sku": "3",
	// 	// 		"label": "Kid & Cargo Duo",
	// 	// 		"code": "all-weather",
	// 	// 		"bundleCode": "cargo",
	// 	// 		"variantId": 48712864989457,
	// 	// 		"description": "The best of both worlds",
	// 	// 		"bundleDescription": "Includes one Carry & Go Tote Bag and the Thule® Yepp Nexxt 2 Maxi Seat",
	// 	// 		"price": 0,
	// 	// 		"fakePrice": 318.95,
	// 	// 		"link": "",
	// 	// 		"optionImage": "https://images.radioflyer.com/media/flyer/build/886/cargo.png",
	// 	// 		"cartImage": "",
	// 	// 		"allowQty": false,
	// 	// 		"currQty": ko.observable(1),
	// 	// 		"selected": ko.observable(false),
	// 	// 		"allowOptions": false,
	// 	// 		"allowDiscount": false,
	// 	// 		"discountPrice": 129,
	// 	// },
	// 	{
	// 		"sku": "4",
	// 		"label": "School Bus Hauling",
	// 		"code": "all-weather",
	// 		"bundleCode": "school",
	// 		"variantId": 48712864989457,
	// 		"description": "The ultimate kid carrying accessory",
	// 		"bundleDescription": "Includes the Kid & Cargo™ Carrier XL Hauler",
	// 		"price": 0,
	// 		"fakePrice": 149.00,
	// 		"link": "",
	// 		"optionImage": "https://images.radioflyer.com/media/flyer/build/886/school.png",
	// 		"cartImage": "",
	// 		"allowQty": false,
	// 		"currQty": ko.observable(1),
	// 		"selected": ko.observable(false),
	// 		"allowOptions": false,
	// 		"allowDiscount": false,
	// 		"discountPrice": 129,
	// },

	// 			]
	// 		},
			{
				"optionLabel": "Kid Carrying Accessories",
				"sectionLabel": "Kid & Pet Carriers",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/884/carriers.png",
				"customizeNote": "Add kid & pet carrier accessories to create the perfect ride for your crew.",
				"sectionSelect": ko.observable(false),
				"prevSec": "color",
				"nextSec": "cargo",
				"optionCode": "carriers",
				"type": "checkbox",
				"showOnlyLatest": true,
				"optionItems": [
					{
						"sku": "AC814",
						"label": "Kid & Cargo Carrier",
						"code": "kid-and-cargo-carrier-via",
						"variantId": 49721228493073,
						"description": "Carry two child riders or haul cargo.",
						"price": 199.00,
						"link": "kid-cargo-carrier-hoop-2-kids",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/kid-and-cargo-carrier.png",
								"layer": 1
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/kid-and-cargo-carrier.png",
								"layer": 1
							}
						},
						"optionImage": "https://cdn.shopify.com/s/files/1/0776/3404/4189/files/884-886-AC814-right.jpg?v=1724177350",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC814-Bottom.png?v=1723647714",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"latestGrouping": "rear",
					},
					{
						"sku": "AC865",
						"label": "Wag 'N Ride Pet Carrier",
						"code": "wag-n-ride-pet-carrier",
						"variantId": 50135024533777,
						"description": "For pets up to 30 lbs. Feature removable top, 4 mesh windows, and adjustable leash.",
						"price": 149.00,
						"link": "wag-n-ride-pet-carrier",
						"displayImages": {
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/886-BUILD-AC865BK-AC814BK.png?v=1724252792",
								"layer": 7
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/886-BUILD-AC865BK-AC814BK.png?v=1724252792",
								"layer": 7
							}
						},
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC865BK-AC807BK-right.png?v=1723647714",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC865BK-AC807BK-bottom.png?v=1723647715",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"maxQty": 2,
						"selected": ko.observable(false),
						"required": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 49,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					},
					{
						"sku": "AC809",
						"label": "Kid & Cargo Carrier XL Hauler",
						"code": "kid-and-cargo-carrier-XL",
						"variantId": 48712875966737,
						"description": "For all weather riding and expanded storage capacity. Zipper side door for easy passenger in and out. Holds up to 150 lbs. Made with 100% recycled fabric.",
						"price": 149.00,
						"link": "kid-cargo-carrier-xl-hauler",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/{OPTION}-kid-and-cargo-carrier-xl.png",
								"layer": 10
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/{OPTION}-kid-and-cargo-carrier-xl.png",
								"layer": 10
							}
						},
						"optionImage": {
							"grey": "https://images.radioflyer.com/media/flyer/build/inset-kid-and-cargo-carrier-xl.png",
							"red": "https://images.radioflyer.com/media/flyer/build/inset-kid-cargo-carrier-xl-red.png"
						},
						"cartImage": {
							"grey": "https://images.radioflyer.com/media/flyer/build/cart-kid-and-cargo-carrier-xl.png",
							"red": "https://images.radioflyer.com/media/flyer/build/cart-kid-cargo-carrier-xl-red.png",
						},
						
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"imageOption": ko.observable('grey'),
						"allowOptions": true,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"required": ko.observable(false),
						"latestGrouping": "rear",
						"options": [
							{
								"sku": "",
								"swatch": "grey",
								"code": "grey",
								"variantId": 50582937141521,
								"label": "Grey",
								"selected": ko.observable(true)
							},
							{
								"sku": "R",
								"swatch": "#c71c2d",
								"code": "red",
								"variantId": 50582937174289,
								"label": "Red",
								"selected": ko.observable(false)
							}
						]
					},

					{
						"sku": "AC839",
						"label": "Kid & Cargo Carrier Cover",
						"code": "kid-cargo-carrier-cover",
						"variantId": 48712864989457,
						"description": "Keeps your items dry on the go. Made with 100% recycled fabric.",
						"price": 39.00,
						"link": "kid-cargo-carrier-cover",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-kid-cargo-carrier-cover.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-kid-cargo-carrier-cover.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 129,
					},
					{
						"sku": "AC815",
						"label": "Kid & Cargo Carrier Canopy",
						"code": "kid-and-cargo-carrier-canopy",
						"variantId": 48712872165649,
						"description": "Protective, high-visibility canopy for all weather riding.",
						"notes": "",
						"price": 199.00,
						"link": "kid-cargo-canopy",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/kid-and-cargo-canopy.png",
								"layer": 10
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/kid-and-cargo-canopy.png",
								"layer": 10
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-kid-and-cargo-canopy.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-kid-and-cargo-canopy.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"required": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"latestGrouping": "rear"
					},
					{
						"sku": "822Z",
						"label": "Flyer™ Duoflex",
						"code": "flyer-duoflex",
						"variantId": 47317443019025,
						"description": "From roll to stroll, the Flyer™ Duoflex is the ultimate bike trailer and double stroller for on-the-go families.",
						"price": 429.00,
						"link": "flyer-duoflex",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-flyer-duoflex.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-flyer-duoflex.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"discountPrice": 0,
						"allowDiscount": false
					},
					{
						"sku": "AC844",
						"label": "Thule Yepp Nexxt 2 Maxi Seat",
						"code": "thule-yepp-maxi-2-seat",
						"variantId": 47613239755025,
						"description": "For all weather riding and expanded storage capacity. Zipper side door for easy passenger in and out. Holds up to 150 lbs. Made with 100% recycled fabric.",
						"price": 279.95,
						"link": "thule-yepp-nexxt-2-maxi-seat",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-thule-yepp-nexxt-child-seat.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-thule-yepp-nexxt-child-seat.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"required": ko.observable(false),
						"maxQty": 2,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"latest": false,
						"latestGrouping": "rear",
						"discountPrice": 0,
						"displayImages": {
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/Thule-Single-886.png?v=1724698394",
								"layer": 10
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/Thule-Single-886.png?v=1724698394",
								"layer": 10
							}
						},
					}
				]
			},
			{
				"optionLabel": "Cargo Storage",
				"sectionLabel": "Cargo Storage",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/884/cargo-storage.png",
				"customizeNote": "Choose the storage solution that is right for you by selecting from our assortment of cargo accessories.",
				"sectionSelect": ko.observable(false),
				"prevSec": "carriers",
				"nextSec": "safety",
				"optionCode": "cargo",
				"type": "checkbox",
				"showOnlyLatest": true,
				"optionItems": [
				
					// {
					// 	"sku": "AC841",
					// 	"label": "Waterproof Front Storage Case & Basket",
					// 	"code": "wp-front-storage-case",
					// 	"variantId": 49907988529425,
					// 	"description": "Waterproof case holds up to 25 lbs. Securely attaches to the frame of the Flyer™ Front Storage Basket (Front Storage Basket included).",
					// 	"price": 228.00,
					// 	"link": "waterproof-front-storage-case-basket-black-bundle",
					// 	"displayImages": {
					// 		"hero": {
					// 			"image": "https://images.radioflyer.com/media/flyer/build/886/front-storage-basket-waterproof.png",
					// 			"layer": 7
					// 		},
					// 		"profile": {
					// 			"image": "https://images.radioflyer.com/media/flyer/build/886/front-storage-basket-waterproof.png",
					// 			"layer": 7
					// 		}
					// 	},
					// 	"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-front-wp-storage-bk.png",
					// 	"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-front-storage-waterproof.png",
					// 	"allowQty": false,
					// 	"latest": false,
					// 	"currQty": ko.observable(1),
					// 	"selected": ko.observable(false),
					// 	"allowOptions": false,
					// 	"allowDiscount": false,
					// 	"discountPrice": 129,
					// 	"grouping": "small-front",
					// 	"latestGrouping": "front"
					// },

					{
						"sku": "AC801BK",
						"label": "Front Storage Basket",
						"code": "front-storage-basket-black",
						"variantId": 48712895136017,
						"description": "Holds up to 25 lbs. Made with 100% recycled fabric. ",
						"price": 129.00,
						"link": "front-storage-basket-black",
						"notes": "",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/front-storage-basket.png",
								"layer": 7
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/front-storage-basket.png",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-front-storage-bk-new.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-front-storage-bk.png",
						"allowQty": false,
						"latest": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"grouping": "small-front",
						"latestGrouping": "front"
					},
					{
						"sku": "AC805BK",
						"label": "Front Rack",
						"code": "rack",
						"variantId": 48712883732753,
						"description": "Provides versatility & expands your hauling capacity. Holds up to 30 lbs",
						"price": 99.00,
						"link": "front-rack-black",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/front-rack.png",
								"layer": 7
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/front-rack.png",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-front-rack-bk.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-front-rack-bk.png",
						"allowQty": false,
						"latest": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 39,
						"latestGrouping": "front"
					},
					{
						"sku": "AC869",
						"label": "36L Soft Cooler",
						"code": "36l-soft-cooler",
						"variantId": 50940682076433,
						"description": "Perfect for traveling & on-the-go adventures. Insulated, durable, and waterproof. Holds up to 80 lbs.",
						"price": 149.00,
						"link": "36l-soft-cooler",
						"displayImages": {
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/AC869-{QTY}.png",
								"layer": 8
							},
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/AC869-{QTY}.png",
								"layer": 8
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/ac869-cooler.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/ac869-cooler.png",
						"latest": false,
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 2,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 49,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					},
					{
						"sku": "AC808",
						"label": "Carry & Go Tote Bag",
						"code": "carry-go-tote",
						"variantId": 48712879309073,
						"description": "Holds up to 60 lbs. and features internal zipper pocket. Folds flat on bike. Made with 100% recycled fabric.",
						"price": 69.00,
						"link": "carry-go-tote-bag",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/carry-go-tote-{QTY}.png",
								"layer": 8
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/carry-go-tote-{QTY}.png",
								"layer": 8
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-carry-go-tote.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-carry-go-tote.png",
						"latest": false,
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 2,
						"selected": ko.observable(false),
						"required": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 49,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					},
					{
						"sku": "AC847",
						"label": "Waterproof Frame Storage Case",
						"code": "wp-frame-storage-bag",
						"variantId": 47317479784721,
						"description": "Waterproof storage. Holds up to 6 lbs. Great for keys, wallets, and phones.",
						"price": 34.00,
						"link": "waterproof-frame-storage-case",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/frame-storage-waterproof.png",
								"layer": 9
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/frame-storage-waterproof.png",
								"layer": 9
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-frame-storage-847.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-frame-storage-waterproof.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"latest": false,
						"discountPrice": 0,
					},
					{
						"sku": "AC874",
						"label": "Catch-All Bag",
						"code": "catch-all",
						"variantId": 50582958965009,
						"description": "Convenient on-the-go storage. Holds a 32 oz. water bottle or up to 6 lbs. Great for phones, keys, or snacks. Features external mesh pocket and Velcro straps for secure attachment.",
						"notes": "",
						"price": 15.00,
						"link": "catch-all-bag",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/catch-all.png",
								"layer": 10
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/catch-all.png",
								"layer": 10
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-catch-all.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-ac874.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"required": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
					},
					
					{
						"sku": "AC846",
						"label": "Waterproof Pannier Bag",
						"code": "wp-pannier-bag",
						"variantId": 47317469528337,
						"description": "Waterproof storage. Holds up to 25 lbs. Quick disconnect for easy on & off.",
						"price": 149.00,
						"link": "waterproof-pannier-bag",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/886-pannier.png",
								"layer": 7
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/886-pannier.png",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-pannier-bag.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/shown-on-bike-pannier.png",
						"allowQty": true,
						"latest": false,
						"currQty": ko.observable(1),
						"maxQty": 2,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"latestGrouping": "rear"
					},
					
					{
						"sku": "AC834",
						"label": "Cargo Straps (2 Pack)",
						"code": "cargo-straps",
						"variantId": 47317447278865,
						"description": "Secure your belongings on the go. Durable, stretchable material. Pack includes 2 straps.",
						"price": 10.00,
						"link": "cargo-straps",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-cargo-straps.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-cargo-straps.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC835",
						"label": "Cargo Net",
						"code": "cargo-net",
						"variantId": 47317448032529,
						"description": "Secure your belongings on the go. Durable, stretchable material.",
						"price": 10.00,
						"link": "cargo-net",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-cargo-net.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-cargo-net.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					}

				]
			},
			{
				"optionLabel": "Safety & Security",
				"sectionLabel": "Safety & Security",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/885/safe-secure.png?d=628",
				"customizeNote": "Explore accessories designed to keep you and your passengers safe and your bike secure.",
				"sectionSelect": ko.observable(false),
				"prevSec": "cargo",
				"nextSec": "rider-extras",
				"optionCode": "safety",
				"type": "checkbox",
				"showOnlyLatest": false,
				"optionItems": [
				{
						"sku": "AC827",
						"label": "Bar End Bike Mirror",
						"code": "rear-view-mirror",
						"variantId": 47317351203089,
						"description": "Blindspot coverage while you ride. Splash and crack resistant.",
						"price": 39.00,
						"link": "bar-end-bike-mirror",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/860/AC827.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-side-mirror.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"displayImages": {
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/side-mirror.png",
								"layer": 8
							},
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/side-mirror.png",
								"layer": 8
							}
						}
					},
					{
						"sku": "AC855",
						"label": "Kryptonite® Evolution 1090 Integrated",
						"code": "lock",
						"variantId": 47317319418129,
						"description": "High security 3’ heavy duty chain lock",
						"price": 120.95,
						"link": "kryptonite-evolution-1090",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-1090.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-1090.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC856",
						"label": "Kryptonite® KryptoLok 610 S Folding Lock ",
						"code": "lock",
						"variantId": 47317319647505,
						"description": "Moderate security compact folding lock",
						"price": 142.95,
						"link": "kryptonite-kryptolok-610",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-610.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-610.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC857",
						"label": "Kryptonite® Evolution Standard U Lock",
						"code": "lock",
						"variantId": 47317319909649,
						"description": "High security 14 mm steel U-lock",
						"price": 129.95,
						"link": "kryptonite-evolution-standard-u-lock",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-evolution.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-evolution.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC858",
						"label": "Kryptonite® KryptoLok Standard U",
						"code": "lock",
						"variantId": 47317320073489,
						"description": "Moderate security 12.7 mm steel U-lock",
						"price": 72.95,
						"link": "kryptonite-kryptolok-standard-u-lock",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-krypto.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-krypto.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC859",
						"label": "Kryptonite® KryptoFlex 710 Double Loop Cable ",
						"code": "lock",
						"variantId": 47317320368401,
						"description": "7’ cable to secure front wheel when used with a Kryptonite® lock. Please note this is a cable only (not a lock).",
						"price": 26.95,
						"link": "kryptonite-kryptoflex-710-cable",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-710.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-710.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC818",
						"label": "Bern® Hudson Adult Helmet",
						"code": "bern-hudson-adult-helmet",
						"description": "The optimal combination of style, comfort, and protection.",
						"price": 159.00,
						"link": "bern-hudson-adult-helmet",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/ac818-img-hero.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/ac818-img-cart-small.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": true,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"options": [
							{
								"sku": "S",
								"code": "small",
								"variantId": 47317277245713,
								"label": "Small",
								"selected": ko.observable(false)
							},
							/*{
								"sku": "M",
								"code": "medium",
								"variantId": 47317277475089,
								"label": "Medium",
								"selected": ko.observable(true)
							},*/
							{
								"sku": "L",
								"code": "large",
								"variantId": 47317277606161,
								"label": "Large",
								"selected": ko.observable(true)
							}
						]
					},
					{
						"sku": "AC876BK",
						"label": "Bern® Nino DVRT Youth Helmet, Black",
						"code": "bern-nino-dvrt-youth-helmet-black",
						"description": "Safe, stylish, and designed for a quick and easy fit for young riders.",
						"price": 79.00,
						"link": "bern-nino-dvrt-youth-helmet-black",
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2.png",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": true,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"options": [
							{
								"sku": "XS/S",
								"code": "small",
								"variantId": 50030924955921,
								"label": "Small",
								"selected": ko.observable(false)
							},
							 {
								"sku": "S/M",
								"code": "medium",
								"variantId": 50030924988689,
								"label": "Medium",
								"selected": ko.observable(true)
							} 
						]
					},
					{
						"sku": "AC876BL",
						"label": "Bern® Nino DVRT Youth Helmet, Blue",
						"code": "bern-nino-dvrt-youth-helmet-blue",
						"description": "Safe, stylish, and designed for a quick and easy fit for young riders.",
						"price": 79.00,
						"link": "bern-nino-dvrt-youth-helmet-blue",
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2-blue.png",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2-blue.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": true,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"options": [
							{
								"sku": "XS/S",
								"code": "small",
								"variantId": 50030906835217,
								"label": "Small",
								"selected": ko.observable(false)
							},
							{
								"sku": "S/M",
								"code": "medium",
								"variantId": 50030906867985,
								"label": "Medium",
								"selected": ko.observable(true)
							}
						]
					}
					
				]
			},
			{
				"optionLabel": "Rider Extras",
				"sectionLabel": "Rider Extras",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/885/rider-extra.png",
				"customizeNote": "Load your electric bike with all of the accessories you need for a comfortable ride.",
				"sectionSelect": ko.observable(false),
				"prevSec": "safety",
				"nextSec": "review",
				"optionCode": "rider-extras",
				"type": "checkbox",
				"showOnlyLatest": false,
				"optionItems": [
					{
						"sku": "AC849",
						"label": "Waterproof Bike Cover",
						"code": "waterproof-bike-cover",
						"variantId": 49941773451537,
						"description": "Protect your bike from the elements.",
						"price": 64.00,
						"link": "waterproof-bike-cover",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-waterproof-bike-cover.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-waterproof-bike-cover.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC822",
						"label": "Cell Phone Mount",
						"code": "cell-phone-mount",
						"variantId": 47317263417617,
						"description": "Secure your phone while you ride. Compatible with phones 3.5”-6.5''",
						"price": 29.00,
						"link": "",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-cell-phone.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-cell-phone.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					},{
						"sku": "AC828",
						"label": "Water Bottle Cage",
						"code": "water-bottle-cage",
						"description": "Holds any standard-sized water bottle. Quick release for easy access.",
						"price": 19.00,
						"link": "",
						"optionImage": {
							"black": "https://images.radioflyer.com/media/flyer/build/860/AC828B.png",
							"silver": "https://images.radioflyer.com/media/flyer/build/860/AC828S.png"
						},
						"cartImage": {
							"black": "https://images.radioflyer.com/media/flyer/build/cart-water-cage-black.png",
							"silver": "https://images.radioflyer.com/media/flyer/build/cart-water-cage-silver.png",
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"imageOption": ko.observable('black'),
						"allowOptions": true,
						"flyerProd": true,
						"latest": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"displayImages": {
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/{OPTION}-water-cage.png?d=119",
								"layer": 8
							},
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/{OPTION}-water-cage-hero.png",
								"layer": 8
							}
						},
						"options": [
							{
								"sku": "B",
								"swatch": "black",
								"code": "black",
								"variantId": 47317354938641,
								"label": "Black",
								"selected": ko.observable(true)
							},
							{
								"sku": "S",
								"swatch": "#d9d9db",
								"code": "silver",
								"variantId": 47317355626769,
								"label": "Silver",
								"selected": ko.observable(false)
							}
						]
					},
					{
						"sku": "AC824",
						"label": "Water Bottle",
						"code": "water-bottle",
						"variantId": 47317264466193,
						"description": "Hydrate on the go with this BPA free 20 oz. water bottle.",
						"price": 14.00,
						"link": "",
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/products/water-bottle-model-ac822-shop.jpg",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-water-bottle.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					}, 
					{
						"sku": "AC838",
						"label": "Battery & Charger Holder",
						"code": "water-bottle",
						"variantId": 47317512552721,
						"description": "Secure storage for your Flyer™ eBike battery & charger.",
						"price": 49.00,
						"link": "battery-charger-holder",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-ac838.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-ac838.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					}  /*
					{
						"sku": "AC823",
						"label": "Bike Lock",
						"code": "bike-lock",
						"description": "Secure your bike with confidence. Features a crossbar design, deadbolt with steel shackle, and weatherproof nylon cover for long-lasting protection.",
						"price": 99.99,
						"link": "",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-bike-lock.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-bike-lock.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false
					},
					{
						"sku": "AC820",
						"label": "Bell® Daily MIPS Adult Helmet, Universal Adult",
						"code": "universal-adult-helmet",
						"description": "Comfortable, stylish, and safe – light up your ride with the Bell® Daily MIPS LED Adult Helmet. Fits head size of 54-61 cm. Ships November 2021.",
						"price": 119.00,
						"link": "bell-daily-mips-led-adult-helmet.html",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-adult-helmet.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-adult-helmet.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false
					},
					{
						"sku": "AC819",
						"label": "Bell® Daily MIPS Adult Helmet, Universal Women's",
						"code": "universal-womens-helmet",
						"description": "Comfortable, stylish, and safe – light up your ride with the Bell® Daily MIPS LED Adult Helmet. Fits head size of 50-57 cm. Ships November 2021.",
						"price": 119.00,
						"link": "bell-daily-mips-led-adult-helmet-uw.html",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-adult-helmet.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-adult-helmet.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false
					},*/

				]
			}
		]
	},
	"FLYER-881": {
		"title": "Flyer<sup>&trade;</sup> Flex",
		"options": [
			{
				"optionLabel": "Color",
				"sectionLabel": "Frame Size, Color & Battery",
				"noSize": false,
				"sectionImg": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/size-color.png?v=1723738384",
				"customizeNote": "Find your perfect fit. Customize with your choice of color and battery range.",
				"sectionSelect": ko.observable(false),
				"optionCode": "color",
				"type": "radio",
				"selectedOption": ko.observable(),
				"optionItems": [
					{
						"sku": "881BK",
						"label": "Black",
						"reviewLabel": "Black 881",
						"code": "black",
						"price": 2299.00,
						"swatch": "#000000",
						"displayImages": {
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-Profile-Black.jpg?v=1723573116",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/886/profile-black.png?d=42022"
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0001_BLACK.png?v=1723576690",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/886/hero-black.png?d=42022"
							}
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"allowDiscount": false,
						"discountPrice": 0,
						"disabled": ko.observable(false)
					},
					{
						"sku": "881BL",
						"label": "Space Gray Blue",
						"reviewLabel": "Space Gray Blue 881",
						"code": "blue",
						"price": 2299.00,
						"swatch": "#B2C3C6",
						"displayImages": {
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-Profile-Black.jpg?v=1723573116",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/886/profile-white.png?d=42022"
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000_BLUE_3de31eb9-886f-4635-a079-b3855c8592e3.png?v=1723576690",
								"layer": 1,
								"thumbnail": "https://images.radioflyer.com/media/flyer/build/886/hero-white.png?d=42022"
							}
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"allowDiscount": false,
						"discountPrice": 0,
						"disabled": ko.observable(false)
					}
				]
			},
			{
				"optionLabel": "Frame Size",
				"optionCode": "size",
				"extBattery": true,
				"type": "radio",
				"sectionLabel": "",
				"customizeNote": "",
				"sectionSelect": ko.observable(false),
				"nextSec": "carriers",
				"selectedOption": ko.observable(),
				"optionItems": [
					{
						"sku": "M",
						"label": "5'0'' - 6'0''",
						"reviewLabel": "Small/Medium Frame Size (5'0'' - 6'0'')",
						"code": "S/M",
						"price": 0.00,
						"swatch": "S/M",
						"allowQty": false,
						"currQty": ko.observable(1),
						"disabled": ko.observable(false)
					},
					{
						"sku": "L",
						"label": "5'5'' - 6'5''",
						"reviewLabel": "Medium/Large Frame Size (5'5'' - 6'5'')",
						"code": "M/L",
						"price": 0.00,
						"swatch": "M/L",
						"allowQty": false,
						"currQty": ko.observable(1),
						"disabled": ko.observable(false)
					}
				]
			},
			{
				"optionLabel": "Battery",
				"optionCode": "battery",
				"type": "radio",
				"sectionLabel": "",
				"customizeNote": "",
				"sectionSelect": ko.observable(false),
				"nextSec": "carriers",
				"selectedOption": ko.observable(),
				"optionItems": [
					{
						"sku": "",
						"label": "20-40+ miles per charge",
						"reviewLabel": "Standard ",
						"extraNote": "",
						"code": "standard",
						"price": 0.00,
						"swatch": "Standard",
						"allowQty": false,
						"currQty": ko.observable(1),
						"disabled": ko.observable(false)
					},
					{
						"sku": "XR",
						"label": "30-50+ miles per charge",
						"reviewLabel": "Extended Range ",
						"code": "extended",
						"extraNote": "50% more range",
						"price": 200.00,
						"swatch": "Extended Range ",
						"allowQty": false,
						"currQty": ko.observable(1),
						"disabled": ko.observable(false)
					}
				]
			},
			// {
			// 	"optionLabel": "Popular Accessory Combos",
			// 	"sectionLabel": "Popular Accessory Combos",
			// 	"sectionImg": "https://images.radioflyer.com/media/flyer/build/886/menu-bundles-886.png",
			// 	"customizeNote": "Create the perfect ride for your crew with our extensive accessory system. Get started with one of our recommended accessory sets. ",
			// 	"sectionSelect": ko.observable(false),
			// 	"prevSec": "color",
			// 	"nextSec": "carriers",
			// 	"optionCode": "favorites",
			// 	"type": "checkbox",
			// 	"showOnlyLatest": false,
			// 	"optionItems": [
			// 		{
			// 			"sku": "1",
			// 			"label": "All Weather Riding",
			// 			"code": "all-weather",
			// 			"bundleCode": "weather",
			// 			"variantId": 48712864989457,
			// 			"description": "Protect little riders from the elements",
			// 			"bundleDescription": "Includes the Kid & Cargo™ Canopy and Kid & Cargo™ Carrier XL Hauler",
			// 			"price": 0,
			// 			"fakePrice": 348.00,
			// 			"link": "",
			// 			"optionImage": "https://images.radioflyer.com/media/flyer/build/886/all-weather.png",
			// 			"cartImage": "",
			// 			"allowQty": false,
			// 			"currQty": ko.observable(1),
			// 			"selected": ko.observable(false),
			// 			"allowOptions": false,
			// 			"allowDiscount": false,
			// 			"discountPrice": 129,
			// 	},
			// 	{
			// 		"sku": "2",
			// 		"label": "Grocery Workhorse",
			// 		"code": "all-weather",
			// 		"bundleCode": "grocery",
			// 		"variantId": 48712864989457,
			// 		"description": "For versatile cargo carrying",
			// 		"bundleDescription": "Includes two Carry & Go Tote Bags",
			// 		"price": 0,
			// 		"fakePrice": 138.00,
			// 		"link": "",
			// 		"optionImage": "https://images.radioflyer.com/media/flyer/build/886/grocery.png",
			// 		"cartImage": "",
			// 		"allowQty": false,
			// 		"currQty": ko.observable(1),
			// 		"selected": ko.observable(false),
			// 		"allowOptions": false,
			// 		"allowDiscount": false,
			// 		"discountPrice": 129,
			// },
		// 	{
		// 		"sku": "3",
		// 		"label": "Kid & Cargo Duo",
		// 		"code": "all-weather",
		// 		"bundleCode": "cargo",
		// 		"variantId": 48712864989457,
		// 		"description": "The best of both worlds",
		// 		"bundleDescription": "Includes one Carry & Go Tote Bag and the Thule® Yepp Nexxt 2 Maxi Seat",
		// 		"price": 0,
		// 		"fakePrice": 318.95,
		// 		"link": "",
		// 		"optionImage": "https://images.radioflyer.com/media/flyer/build/886/cargo.png",
		// 		"cartImage": "",
		// 		"allowQty": false,
		// 		"currQty": ko.observable(1),
		// 		"selected": ko.observable(false),
		// 		"allowOptions": false,
		// 		"allowDiscount": false,
		// 		"discountPrice": 129,
		// },
	// 	{
	// 		"sku": "4",
	// 		"label": "School Bus Hauling",
	// 		"code": "all-weather",
	// 		"bundleCode": "school",
	// 		"variantId": 48712864989457,
	// 		"description": "The ultimate kid carrying accessory",
	// 		"bundleDescription": "Includes the Kid & Cargo™ Carrier XL Hauler",
	// 		"price": 0,
	// 		"fakePrice": 149.00,
	// 		"link": "",
	// 		"optionImage": "https://images.radioflyer.com/media/flyer/build/886/school.png",
	// 		"cartImage": "",
	// 		"allowQty": false,
	// 		"currQty": ko.observable(1),
	// 		"selected": ko.observable(false),
	// 		"allowOptions": false,
	// 		"allowDiscount": false,
	// 		"discountPrice": 129,
	// },

	// 			]
	// 		},
			{
				"optionLabel": "Kid Carrying Accessories",
				"sectionLabel": "Kid & Pet Carriers",
				"sectionImg": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC807BK-bottom.png?v=1723647714",
				"customizeNote": "Add kid & pet carrier accessories to create the perfect ride for your crew.",
				"sectionSelect": ko.observable(false),
				"prevSec": "color",
				"nextSec": "cargo",
				"optionCode": "carriers",
				"type": "checkbox",
				"showOnlyLatest": true,
				"optionItems": [
					{
						"sku": "AC807BK",
						"label": "Kid & Cargo™ Carrier - 1 Kid",
						"code": "kid-cargo-carrier-1-kid",
						"variantId": 49948012347665,
						"description": "Ultimate versatility: travel with 1 kid passenger ages 5-10 years or haul up to 65 lbs.",
						"price": 199.00,
						"link": "kid-cargo-carrier-black-1-kid",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/880/kid-cargo-carrier.png",
								"layer": 2
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0013_AC807BK---hoop.png?v=1723576687",
								"layer": 2
							}
						},
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-AC807-right.png?v=1723650677",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC807BK-bottom.png?v=1723647714",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 129.00,
						"latestGrouping": "rear"
					},
					{
						"sku": "AC865",
						"label": "Wag 'N Ride Pet Carrier",
						"code": "wag-n-ride-pet-carrier",
						"variantId": 50135024533777,
						"description": "For pets up to 30 lbs. Feature removable top, 4 mesh windows, and adjustable leash.",
						"price": 149.00,
						"link": "wag-n-ride-pet-carrier",
						"displayImages": {
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/pet_carrier-881.png?v=1742417736",
								"layer": 7
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/pet_carrier-881.png?v=1742417736",
								"layer": 7
							}
						},
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC865-right.png?v=1723738465",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC865BK-AC807BK-bottom.png?v=1723647715",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"maxQty": 2,
						"selected": ko.observable(false),
						"required": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 49,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					},
					{
						"sku": "AC806BK",
						"label": "Kid Carrier",
						"code": "kid-carrier",
						"variantId": 49948038168849,
						"description": "Bring 1 kid passenger ages 5-10 years old along for the ride with this comfortable kid carrier seat.",
						"price": 149.00,
						"link": "kid-carrier-black",
						"displayImages": {
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_AC806BK.png?v=1723585814",
								"layer": 2
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_AC806BK.png?v=1723585814",
								"layer": 2
							}
						},
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-AC806-right.png?v=1723650678",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-kid-carrier.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 99,
						"latestGrouping": "rear"
					},
					{
						"sku": "AC844",
						"label": "Thule Yepp Nexxt 2 Maxi Seat",
						"code": "thule-yepp-maxi-2-seat",
						"variantId": 47613239755025,
						"description": "For all weather riding and expanded storage capacity. Zipper side door for easy passenger in and out. Holds up to 150 lbs. Made with 100% recycled fabric.",
						"price": 279.95,
						"link": "thule-yepp-nexxt-2-maxi-seat",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/thule-yepp-{QTY}.png",
								"layer": 10
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0003_AC844---Thule-Seat.png?v=1723576688",
								"layer": 10
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-thule-yepp-nexxt-child-seat.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-thule-yepp-nexxt-child-seat.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"required": ko.observable(false),
						"maxQty": 2,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"latestGrouping": "rear"
					},
					{
						"sku": "822Z",
						"label": "Flyer™ Duoflex",
						"code": "flyer-duoflex",
						"variantId": 47317443019025,
						"description": "From roll to stroll, the Flyer™ Duoflex is the ultimate bike trailer and double stroller for on-the-go families.",
						"price": 429.00,
						"link": "flyer-duoflex",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-flyer-duoflex.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-flyer-duoflex.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"discountPrice": 0,
						"allowDiscount": false
					}
				]
			},
			{
				"optionLabel": "Cargo Storage",
				"sectionLabel": "Cargo Storage",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/884/cargo-storage.png",
				"customizeNote": "Choose the storage solution that is right for you by selecting from our assortment of cargo accessories.",
				"sectionSelect": ko.observable(false),
				"prevSec": "carriers",
				"nextSec": "safety",
				"optionCode": "cargo",
				"type": "checkbox",
				"showOnlyLatest": true,
				"optionItems": [
					{
						"sku": "AC801BK",
						"label": "Front Storage Basket",
						"code": "front-storage-basket-black",
						"variantId": 48712895136017,
						"description": "Holds up to 25 lbs. Made with 100% recycled fabric. ",
						"price": 129.00,
						"link": "front-storage-basket-black",
						"notes": "",
						"displayImages": {
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0016_AC801BK---small-front-basket.png?v=1723576687",
								"layer": 7
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0016_AC801BK---small-front-basket.png?v=1723576687",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-front-storage-bk-new.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-front-storage-bk.png",
						"allowQty": false,
						"latest": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"grouping": "small-front",
						"latestGrouping": "front"
					},
					/* {
						"sku": "AC841BK",
						"label": "Waterproof Front Storage Case & Basket",
						"code": "wp-front-storage-case",
						"variantId": 49907988529425,
						"description": "Waterproof case holds up to 25 lbs. Securely attaches to the frame of the Flyer™ Front Storage Basket (Front Storage Basket included).",
						"price": 228.00,
						"link": "waterproof-front-storage-case-basket-black-bundle",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/front-storage-basket-waterproof.png",
								"layer": 7
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0005_AC841---Waterproof-Front.png?v=1723576687",
								"layer": 7
							}
						},
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC841-right.png?v=1723647714",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC842-bottom.png?v=1723647714",
						"allowQty": false,
						"latest": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 129,
						"grouping": "small-front",
						"latestGrouping": "front"
					}, */
					{
						"sku": "AC805BK",
						"label": "Front Rack",
						"code": "rack",
						"variantId": 48712883732753,
						"description": "Provides versatility & expands your hauling capacity. Holds up to 30 lbs",
						"price": 99.00,
						"link": "front-rack-black",
						"displayImages": {
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0014_AC805BK---front-rack.png?v=1723576686",
								"layer": 7
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0014_AC805BK---front-rack.png?v=1723576686",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-front-rack-bk.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-front-rack-bk.png",
						"allowQty": false,
						"latest": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 39,
						"latestGrouping": "front"
					},
					{
						"sku": "AC869",
						"label": "36L Soft Cooler",
						"code": "36l-soft-cooler",
						"variantId": 50940682076433,
						"description": "Perfect for traveling & on-the-go adventures. Insulated, durable, and waterproof. Holds up to 80 lbs.",
						"price": 149.00,
						"link": "36l-soft-cooler",
						"displayImages": {
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/881/AC869.png",
								"layer": 8
							},
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/881/AC869.png",
								"layer": 8
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/ac869-cooler.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/ac869-cooler.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 49,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					},
					{
						"sku": "AC808",
						"label": "Carry & Go Tote Bag",
						"code": "carry-go-tote",
						"variantId": 48712879309073,
						"description": "Holds up to 60 lbs. and features internal zipper pocket. Folds flat on bike. Made with 100% recycled fabric.",
						"price": 69.00,
						"link": "carry-go-tote-bag",
						"displayImages": {
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0012_AC808---Tote-Bag.png?v=1723576688",
								"layer": 7
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0012_AC808---Tote-Bag.png?v=1723576688",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-carry-go-tote.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-carry-go-tote.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"maxQty": 2,
						"selected": ko.observable(false),
						"required": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 49,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					},
                    {
						"sku": "AC802BK",
						"label": "Small Rear Storage Basket",
						"code": "small-rear-storage-basket",
						"variantId": 48712887861521,
						"description": "Holds up to 50 lbs. Great for small bags, purses, & personal items.",
						"price": 129.00,
						"link": "rear-storage-basket-black-small",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0015_AC802BK---small-rear-basket.png?v=1723576687",
								"layer": 8
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0015_AC802BK---small-rear-basket.png?v=1723576687",
								"layer": 8
							}
						},
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC802BK-right.png?v=1723652171",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC802BK-Bottom.png?v=1723652171",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 49,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					},
					/* {
						"sku": "AC842BK",
						"label": "Waterproof Rear Storage Case & Basket",
						"code": "wp-rear-storage-case",
						"variantId": 50138812154129,
						"description": "Waterproof case holds up to 50 lbs. Securely attaches to the frame of the Flyer™ Rear Storage Basket (Rear Storage Basket included).",
						"price": 238.00,
						"link": "waterproof-rear-storage-case-basket-black-bundle",
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0004_AC842---Waterproof-Rear.png?v=1723576686",
								"layer": 7
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0004_AC842---Waterproof-Rear.png?v=1723576686",
								"layer": 7
							}
						},
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC842-right.png?v=1723647715",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/AC841-bottom.png?v=1723647714",
						"allowQty": false,
						"latest": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"allowDiscount": false,
						"discountPrice": 129,
						"grouping": "small-rear",
						"latestGrouping": "rear"
					}, */
					{
						"sku": "AC847",
						"label": "Waterproof Frame Storage Case",
						"code": "wp-frame-storage-case",
						"variantId": 47317479784721,
						"description": "Waterproof storage. Holds up to 6 lbs. Great for keys, wallets, and phones.",
						"price": 34.00,
						"link": "waterproof-frame-storage-case",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/frame-storage-waterproof.png",
								"layer": 9
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0001_AC847---Waterproof-case.png?v=1723576686",
								"layer": 9
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-frame-storage-847.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-frame-storage-waterproof.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC874",
						"label": "Catch-All Bag",
						"code": "catch-all",
						"variantId": 50582958965009,
						"description": "Convenient on-the-go storage. Holds a 32 oz. water bottle or up to 6 lbs. Great for phones, keys, or snacks. Features external mesh pocket and Velcro straps for secure attachment.",
						"notes": "",
						"price": 15.00,
						"link": "catch-all-bag",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/881/catch-all.png",
								"layer": 10
							},
							"profile": {
								"image": "https://images.radioflyer.com/media/flyer/build/881/catch-all.png",
								"layer": 10
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-catch-all.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-ac874.png",
						"latest": false,
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"required": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
					},
					{
						"sku": "AC846",
						"label": "Waterproof Pannier Bag",
						"code": "wp-pannier-bag",
						"variantId": 47317469528337,
						"description": "Waterproof storage. Holds up to 25 lbs. Quick disconnect for easy on & off.",
						"price": 149.00,
						"link": "waterproof-pannier-bag",
						"displayImages": {
							"hero": {
								"image": "https://images.radioflyer.com/media/flyer/build/886/886-pannier.png",
								"layer": 7
							},
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0002_AC846---Pannier.png?v=1723576687",
								"layer": 7
							}
						},
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-pannier-bag.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/shown-on-bike-pannier.png",
						"allowQty": true,
						"latest": false,
						"currQty": ko.observable(1),
						"maxQty": 2,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"latestGrouping": "rear"
					},
					{
						"sku": "AC834",
						"label": "Cargo Straps (2 Pack)",
						"code": "cargo-straps",
						"variantId": 47317447278865,
						"description": "Secure your belongings on the go. Durable, stretchable material. Pack includes 2 straps.",
						"price": 10.00,
						"link": "cargo-straps",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-cargo-straps.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-cargo-straps.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC835",
						"label": "Cargo Net",
						"code": "cargo-net",
						"variantId": 47317448032529,
						"description": "Secure your belongings on the go. Durable, stretchable material.",
						"price": 10.00,
						"link": "cargo-net",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-cargo-net.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-cargo-net.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					}

				]
			},
			{
				"optionLabel": "Safety & Security",
				"sectionLabel": "Safety & Security",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/885/safe-secure.png?d=628",
				"customizeNote": "Explore accessories designed to keep you and your passengers safe and your bike secure.",
				"sectionSelect": ko.observable(false),
				"prevSec": "cargo",
				"nextSec": "rider-extras",
				"optionCode": "safety",
				"type": "checkbox",
				"showOnlyLatest": false,
				"optionItems": [
				{
						"sku": "AC827",
						"label": "Bar End Bike Mirror",
						"code": "rear-view-mirror",
						"variantId": 47317351203089,
						"description": "Blindspot coverage while you ride. Splash and crack resistant.",
						"price": 39.00,
						"link": "bar-end-bike-mirror",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/860/AC827.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-side-mirror.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0011_AC827---mirror.png?v=1723576685",
								"layer": 8
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0011_AC827---mirror.png?v=1723576685",
								"layer": 8
							}
						}
					},
					{
						"sku": "AC855",
						"label": "Kryptonite® Evolution 1090 Integrated",
						"code": "lock",
						"variantId": 47317319418129,
						"description": "High security 3’ heavy duty chain lock",
						"price": 120.95,
						"link": "kryptonite-evolution-1090",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-1090.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-1090.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC856",
						"label": "Kryptonite® KryptoLok 610 S Folding Lock ",
						"code": "lock",
						"variantId": 47317319647505,
						"description": "Moderate security compact folding lock",
						"price": 142.95,
						"link": "kryptonite-kryptolok-610",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-610.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-610.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC857",
						"label": "Kryptonite® Evolution Standard U Lock",
						"code": "lock",
						"variantId": 47317319909649,
						"description": "High security 14 mm steel U-lock",
						"price": 129.95,
						"link": "kryptonite-evolution-standard-u-lock",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-evolution.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-evolution.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC858",
						"label": "Kryptonite® KryptoLok Standard U",
						"code": "lock",
						"variantId": 47317320073489,
						"description": "Moderate security 12.7 mm steel U-lock",
						"price": 72.95,
						"link": "kryptonite-kryptolok-standard-u-lock",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-krypto.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-krypto.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC859",
						"label": "Kryptonite® KryptoFlex 710 Double Loop Cable ",
						"code": "lock",
						"variantId": 47317320368401,
						"description": "7’ cable to secure front wheel when used with a Kryptonite® lock. Please note this is a cable only (not a lock).",
						"price": 26.95,
						"link": "kryptonite-kryptoflex-710-cable",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-710.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-710.png?d=1023",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0
					}, {
						"sku": "AC818",
						"label": "Bern® Hudson Adult Helmet",
						"code": "bern-hudson-adult-helmet",
						"description": "The optimal combination of style, comfort, and protection.",
						"price": 159.00,
						"link": "bern-hudson-adult-helmet",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/ac818-img-hero.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/ac818-img-cart-small.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": true,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"options": [
							{
								"sku": "S",
								"code": "small",
								"variantId": 47317277245713,
								"label": "Small",
								"selected": ko.observable(false)
							},
							/*{
								"sku": "M",
								"code": "medium",
								"variantId": 47317277475089,
								"label": "Medium",
								"selected": ko.observable(true)
							},*/
							{
								"sku": "L",
								"code": "large",
								"variantId": 47317277606161,
								"label": "Large",
								"selected": ko.observable(true)
							}
						]
					},
					{
						"sku": "AC876BK",
						"label": "Bern® Nino DVRT Youth Helmet, Black",
						"code": "bern-nino-dvrt-youth-helmet-black",
						"description": "Safe, stylish, and designed for a quick and easy fit for young riders.",
						"price": 79.00,
						"link": "bern-nino-dvrt-youth-helmet-black",
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2.png",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": true,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"options": [
							{
								"sku": "XS/S",
								"code": "small",
								"variantId": 50030924955921,
								"label": "Small",
								"selected": ko.observable(false)
							},
							 {
								"sku": "S/M",
								"code": "medium",
								"variantId": 50030924988689,
								"label": "Medium",
								"selected": ko.observable(true)
							} 
						]
					},
					{
						"sku": "AC876BL",
						"label": "Bern® Nino DVRT Youth Helmet, Blue",
						"code": "bern-nino-dvrt-youth-helmet-blue",
						"description": "Safe, stylish, and designed for a quick and easy fit for young riders.",
						"price": 79.00,
						"link": "bern-nino-dvrt-youth-helmet-blue",
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2-blue.png",
						"cartImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/3QD-2-blue.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": true,
						"flyerProd": false,
						"allowDiscount": false,
						"discountPrice": 0,
						"options": [
							{
								"sku": "XS/S",
								"code": "small",
								"variantId": 50030906835217,
								"label": "Small",
								"selected": ko.observable(false)
							},
							{
								"sku": "S/M",
								"code": "medium",
								"variantId": 50030906867985,
								"label": "Medium",
								"selected": ko.observable(true)
							}
						]
					}
					
				]
			},
			{
				"optionLabel": "Rider Extras",
				"sectionLabel": "Rider Extras",
				"sectionImg": "https://images.radioflyer.com/media/flyer/build/885/rider-extra.png",
				"customizeNote": "Load your electric bike with all of the accessories you need for a comfortable ride.",
				"sectionSelect": ko.observable(false),
				"prevSec": "safety",
				"nextSec": "review",
				"optionCode": "rider-extras",
				"type": "checkbox",
				"showOnlyLatest": false,
				"optionItems": [
					{
						"sku": "AC848",
						"label": "Waterproof Bike Cover",
						"code": "waterproof-bike-cover",
						"variantId": 49941773451537,
						"description": "Protect your bike from the elements.",
						"price": 59.00,
						"link": "waterproof-bike-cover",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-waterproof-bike-cover.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-waterproof-bike-cover.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					},
					{
						"sku": "AC822",
						"label": "Cell Phone Mount",
						"code": "cell-phone-mount",
						"variantId": 47317263417617,
						"description": "Secure your phone while you ride. Compatible with phones 3.5”-6.5''",
						"price": 29.00,
						"link": "",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-cell-phone.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-cell-phone.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0010_AC822-Cell-Phone-Mount.png?v=1723576686",
								"layer": 8
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0010_AC822-Cell-Phone-Mount.png?v=1723576686",
								"layer": 8
							}
						}
					},{
						"sku": "AC828",
						"label": "Water Bottle Cage",
						"code": "water-bottle-cage",
						"description": "Holds any standard-sized water bottle. Quick release for easy access.",
						"price": 19.00,
						"link": "",
						"optionImage": {
							"black": "https://images.radioflyer.com/media/flyer/build/860/AC828B.png",
							"silver": "https://images.radioflyer.com/media/flyer/build/860/AC828S.png"
						},
						"cartImage": {
							"black": "https://images.radioflyer.com/media/flyer/build/cart-water-cage-black.png",
							"silver": "https://images.radioflyer.com/media/flyer/build/cart-water-cage-silver.png",
						},
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"imageOption": ko.observable('black'),
						"allowOptions": true,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0,
						"displayImages": {
							"profile": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0008_AC828B---Water-Bottle-Cage-Black.png?v=1723576685",
								"layer": 8
							},
							"hero": {
								"image": "https://cdn.shopify.com/s/files/1/0780/4092/4433/files/881-IMG-Hero-3-Quarter_With-Accessories-BUILD_0000s_0008_AC828B---Water-Bottle-Cage-Black.png?v=1723576685",
								"layer": 8
							}
						},
						"options": [
							{
								"sku": "B",
								"swatch": "black",
								"code": "black",
								"variantId": 47317354938641,
								"label": "Black",
								"selected": ko.observable(true)
							},
							{
								"sku": "S",
								"swatch": "#d9d9db",
								"code": "silver",
								"variantId": 47317355626769,
								"label": "Silver",
								"selected": ko.observable(false)
							}
						]
					},
					{
						"sku": "AC824",
						"label": "Water Bottle",
						"code": "water-bottle",
						"variantId": 47317264466193,
						"description": "Hydrate on the go with this BPA free 20 oz. water bottle.",
						"price": 14.00,
						"link": "",
						"optionImage": "https://cdn.shopify.com/s/files/1/0780/4092/4433/products/water-bottle-model-ac822-shop.jpg",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-water-bottle.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					}, 
					{
						"sku": "AC838",
						"label": "Battery & Charger Holder",
						"code": "water-bottle",
						"variantId": 47317512552721,
						"description": "Secure storage for your Flyer™ eBike battery & charger.",
						"price": 49.00,
						"link": "battery-charger-holder",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-ac838.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-ac838.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false,
						"flyerProd": true,
						"allowDiscount": false,
						"discountPrice": 0
					}  /*
					{
						"sku": "AC823",
						"label": "Bike Lock",
						"code": "bike-lock",
						"description": "Secure your bike with confidence. Features a crossbar design, deadbolt with steel shackle, and weatherproof nylon cover for long-lasting protection.",
						"price": 99.99,
						"link": "",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-bike-lock.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-bike-lock.png",
						"allowQty": false,
						"currQty": ko.observable(1),
						"selected": ko.observable(false),
						"allowOptions": false
					},
					{
						"sku": "AC820",
						"label": "Bell® Daily MIPS Adult Helmet, Universal Adult",
						"code": "universal-adult-helmet",
						"description": "Comfortable, stylish, and safe – light up your ride with the Bell® Daily MIPS LED Adult Helmet. Fits head size of 54-61 cm. Ships November 2021.",
						"price": 119.00,
						"link": "bell-daily-mips-led-adult-helmet.html",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-adult-helmet.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-adult-helmet.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false
					},
					{
						"sku": "AC819",
						"label": "Bell® Daily MIPS Adult Helmet, Universal Women's",
						"code": "universal-womens-helmet",
						"description": "Comfortable, stylish, and safe – light up your ride with the Bell® Daily MIPS LED Adult Helmet. Fits head size of 50-57 cm. Ships November 2021.",
						"price": 119.00,
						"link": "bell-daily-mips-led-adult-helmet-uw.html",
						"optionImage": "https://images.radioflyer.com/media/flyer/build/inset-adult-helmet.png",
						"cartImage": "https://images.radioflyer.com/media/flyer/build/cart-adult-helmet.png",
						"allowQty": true,
						"currQty": ko.observable(1),
						"maxQty": 9,
						"selected": ko.observable(false),
						"allowOptions": false
					},*/

				]
			}
		]
	}
}